export const FAX_FEATURE_FLAG = "faxFeature";
export const PATIENT_BALANCE_DETAILS_FEATURE = "patientBalanceDetailsFeature";
export const SHOW_PATIENT_LIST_BALANCE = "showPatientListBalance";
export const PATIENT_STATEMENT_FEATURE_FLAG = "patientStatementFeature";
export const MULTI_PAGE_AUDIOLOGY_REPORT = "multiPageAudiologyReport";
export const AUDIOLOGY_REPORT_DETAIL_TAG_SCOPE =
  "audiologyReportDetailTagScope";
export const AUTOSAVE_CROSS_TAB_COORDINATION = "autosaveCrossTabCoordination";
export const DASHBOARD_FEATURE_FLAG = "dashboardFeature";
export const SCHEDULING_DASHBOARD_VIEW = "schedulingDashboardView";
export const PATIENT_ONBOARDING_FORMS_FEATURE_FLAG =
  "patientOnboardingFormsFeature";
export const DASHBOARD_DESIGN_V2_FEATURE = "dashboardDesignV2Feature";
export const DEMO_LOANERS_FEATURE = "demoLoanersFeature";
export const PATIENT_DOCUMENTS_FEATURE = "patientDocumentsFeature";
export const QUICKBOOKS_ORDERS_SYNC_FEATURE = "quickbooksOrdersSyncFeature";
export const APPOINTMENT_EMAIL_NOTIFICATION_FEATURE =
  "appointmentEmailNotificationFeature";
export const APPOINTMENT_NOTIFY_BOTH_CHANNELS_FEATURE =
  "appointmentNotifyBothChannelsFeature";

export const REPAIR_FORMS_FEATURE = "repairFormsFeature";
export const TEMPLATE_FORMS_FEATURE = "templateFormsFeature";
export const TASK_TEMPLATE_RICH_TEXT_FEATURE = "taskTemplateRichText";
/** SN-19710: "Allow other practice members to edit" on shared text templates. Gates the RestQL
 * field, the PATCH payload key and the checkbox, so the frontend can ship before the backend. */
export const TEMPLATE_SHARED_EDITING_FEATURE = "templateSharedEditing";
export const REPAIR_ELIGIBLE_PRODUCTS_FEATURE = "repairEligibleProducts";
export const REPAIR_WARRANTY_PRICING_FEATURE = "repairWarrantyPricing";
export const ORDER_FORMS_FEATURE = "orderFormsFeature";
export const ORDER_TRACKING_FEATURE = "orderTrackingFeature";
export const TRACKING_NUMBER_FEATURE = "trackingNumber";

export const MARKETING_AUTOMATION_FEATURE = "marketingAutomationFeature";
export const CUSTOM_CAMPAIGNS_FEATURE = "customCampaigns";
export const CALL_BACK_LIST_FEATURE = "callBackList";
export const MARKETING_DASHBOARD_FEATURE = "marketingDashboard";
export const CAMPAIGN_EFFECTIVENESS_FEATURE = "campaignEffectiveness";
export const DIRECT_MAIL_DASHBOARD_FEATURE = "directMailDashboard";

export const CAMPAIGN_BIRTHDAY = "campaignBirthday";
export const CAMPAIGN_HA_WARRANTY = "campaignHaWarranty";
export const CAMPAIGN_HA_CLEAN_AND_CHECK = "campaignHaCleanAndCheck";
export const CAMPAIGN_LAST_BOOKED = "campaignLastBooked";
export const CAMPAIGN_NEW_YEAR = "campaignNewYear";
export const CAMPAIGN_AUDIENCE_FEATURE = "campaignAudience";
// Per-clinic "send the other channel to patients missing this one" switch on
// system campaigns (`ClinicCampaign.fallback_to_other_channel`). Gates both
// the RestQL read field and the PATCH key — an older backend 400s on either.
export const SYSTEM_CAMPAIGN_CHANNEL_FALLBACK_FEATURE =
  "systemCampaignChannelFallback";

export const CAMPAIGN_HEARING_AID_PURCHASED_DAY_1 =
  "campaignHearingAidPurchasedDayOne";

export const CAMPAIGN_HEARING_AID_PURCHASED_WEEK_1_FOLLOW_UP =
  "campaignHearingAidPurchasedWeekOneFollowUp";

export const CAMPAIGN_HEARING_AID_PURCHASED_WEEK_3_FOLLOW_UP =
  "campaignHearingAidPurchasedWeekThreeFollowUp";

export const CAMPAIGN_HEARING_AID_PURCHASED_WEEK_12_FOLLOW_UP =
  "campaignHearingAidPurchasedWeekTwelveFollowUp";

export const CAMPAIGN_ANNUAL_HEARING_EVALUATION =
  "campaignAnnualHearingEvaluation";

export const REACT_PDF_RENDERING_FEATURE = "reactPdfRenderingFeature";

export const HEARING_AIDS_CONVERSIONS_DASHBOARD_FEATURE =
  "haOpportunityConversions";

export const INVOICE_V2_FEATURE = "invoiceV2Feature";

export const SALE_QUOTE = "saleQuote";

export const AUTOMATIC_BALANCED_SALE_COMPLETION_FEATURE =
  "automaticBalancedSaleCompletionFeature";
export const PURCHASE_AGREEMENTS_NEW_FIELDS = "purchaseAgreementsNewFields";

export const PRIOR_AUTHORIZATION_CODES_FEATURE = "priorAuthorizationCodes";
export const ADD_NEW_AUTHORIZATION_CODE_FEATURE =
  "abilityToAddNewAuthorizationCode";
export const TOUCHPOINTS_WORDPROCESSOR_FIELD =
  "touchpointsWordprocessorFeature";
export const EXTENDED_SUB_REFERRAL_SOURCE_FEATURE =
  "patientReferringPhysicianReferralSourceFeature";
export const HCFA_FORM_FEATURE = "hcfaForm";
export const NPI_BILLING_PROVIDER_TOGGLE = "npiBillingProviderToggle";
export const INBOX_SCROLLING_FEATURE = "inboxScrollingFeature";
export const PAYMENTS_REQUESTS_FEATURE = "paymentsRequestsFeature";

export const CHECK_IN_INVENTORY_FEATURE = "checkInInventoryFeature";
export const ORDERS_BULK_COUNTS_ENABLED = "ordersBulkCountsEnabled";
export const SCHEDULER_GROUP_BY_CLINICS = "schedulerGroupByClinics";
export const SCHEDULER_CLINIC_HOURS_WINDOW = "schedulerClinicHoursWindow";
export const SHOW_PATIENT_SEARCH_ALERT_COUNT = "showPatientSearchAlertCount";
export const DIRECT_SCANNING = "directScanning";
// DEV-2806. Routes the Scan Document modal to the hardened fork in
// `features/dynamic-web-twain-v2/`. OFF keeps the untouched original.
export const DIRECT_SCANNING_V2 = "directScanningV2";
export const APPOINTMENT_FORMS_FEATURE = "appointmentFormsFeature";
export const BOX_MOVE_FILES = "boxMoveFiles";
export const BOX_DRAG_DROP_MOVE = "boxDragDropMove";
// SN-19727. E-Documents "Move Files": a "Move to…" button in the
// drag-and-drop modal, and a name clash keeps both files (numbered) instead of
// refusing the move. OFF keeps today's modals.
export const EDOCS_MOVE_TO_BUTTON = "edocsMoveToButton";
export const SHOW_NOAH_SESSION_HISTORY = "showNoahSessionHistory";
export const DASHBOARD_PERIOD_COMPARISON_FEATURE =
  "dashboardPeriodComparisonFeature";
export const SCHEDULING_COLLAPSIBLE_FILTERS_PANEL =
  "schedulingCollapsibleFiltersPanel";
export const APPOINTMENT_TYPES_NOTIFICATIONS = "appointmentTypesNotifications";
export const INSURANCE_PAYMENTS_AND_ADJUSTMENTS_FEATURE =
  "insurancePaymentsAndAdjustments";
export const TYMPANOGRAM_PDF_REPORT_FEATURE = "tympanogramPdfReportFeature";
export const TYMPANOGRAM_AUTO_DRAW_FEATURE = "tympanogramAutoDrawFeature";
export const VISUALIZATION_MODAL = "visualizationModal";
export const ONTARIO_ADP_FEATURE = "ontarioAdp";
export const SINGLE_PAGE_SALE_FEATURE = "singlePageSaleFeature";
export const SUPPLIER_PRICE_FIELD_IS_ENABLED = "supplierPrice";
export const CLINIC_STOCK_VALUE_ENABLED = "clinicStockValueEnabled";
export const SALES_DELIVERED_AT_FIELD = "salesDeliveredAtField";

export const FITTING_DELIVERY_DATE_SELECTOR = "fittingDeliveryDateSelector";
export const REPORT_SECONDARY_PROVIDER_FEATURE = "reportSecondaryProvider";
export const PDF_EDITING_FEATURE = "pdfEditingFeature";
export const REPORT_INCLUDE_TYMPANOMETRY_GRAPHS_FEATURE =
  "includeTympanometryGraphs";
export const DISCOUNT_TYPES_FEATURE = "discountTypesFeature";
export const SHOW_HEARING_AIDS_IN_SPS = "showHearingAidsInSps";
export const GLOBAL_PRACTICE_EVENTS_FEATURE = "globalPracticeEventFeature";
export const PRICE_TABLES_FEATURE = "priceTablesFeature";
export const CLINIC_EVENTS_FEATURE = "clinicEventsFeature";
export const MANAGE_EXISTING_PAYMENTS_ADJUSTMENTS_FEATURE =
  "manageExistingPaymentsAdjustmentsFeatue";
export const AR_OVERVIEW_FEATURE = "arOverview";
export const REGIONS_SELECTOR_FEATURE = "regionsSelector";
// LD key: clinic-selector-display-name (read as clinicSelectorDisplayName). Top-bar clinic dropdown (practices without the regions selector):
// a clinic whose own display name is set is listed by that name instead of "<practice> <clinic>", on
// screens >= xl (narrower screens already show only the short clinic name). Not used when the name
// is just the practice name or would repeat another row. Suno staff see the same labels as the clinic.
// Off => the dropdown and its requests are exactly as before. A new LD flag starts on, so create it
// serving false and check `on` + fallthrough in every environment.
export const CLINIC_SELECTOR_DISPLAY_NAME_FEATURE = "clinicSelectorDisplayName";
export const HEARING_AID_HIDE_INVOICE_OPTIONS = "haHideInvoiceOptions";
export const PARTIAL_ORDER_CHECKIN_FEATURE = "partialOrderCheckInFeature";
export const QUICKBOOKS_TOKENS_FEATURE = "quickbooksToken";
export const QUICKBOOKS_PRODUCTS_FEATURE = "quickbooksProducts";
export const VIEW_WORK_SHIFT_IN_SCHEDULER = "viewWorkShiftInScheduler";
export const CHS_REPORT_FEATURE = "chsReport";
export const PRIVATE_PAY_AGING_REPORT = "privatePayAgingReport";
export const TESTED_NOT_SOLD_REPORT = "testedNotSoldReport";
export const MANAGED_CARE_AGING_REPORT = "managedCarePartyAgingReport";
export const MANAGED_CARE_HEARING_AID_UNITS_REPORT =
  "managedCareHearingAidUnitsReport";
export const AR_SNAPSHOT_REPORT = "arSnapshotReport";
export const NEW_PATIENT_APPOINTMENTS_REPORT = "newPatientAppointmentsReport";
export const OPEN_INVENTORY_REPORT_FEATURE = "openInventoryReport";
export const DELETING_PATIENT_PRODUCT_FEATURE = "deletingPatientProduct";
export const ACH_CHECK_TILLED_INTEGRATION = "achCheckTilledIntegration";
export const ABILITY_TO_LOG_GENERATED_STATEMENT =
  "abilityToLogGeneratedStatement";
export const INCLUDE_OVERPAID_SALES_IN_STATEMENTS =
  "includeOverpaidSalesInStatements";
export const RETURN_LINE_ITEM = "returnLineItem";
export const SUNO_COMMS_FEATURE = "sunoCommsFeature";
export const INSURER_CPT_CODES_USAGE_REPORT = "insurerCptCodesUsageReport";
export const PRACTICE_TAGS_FEATURE = "globalTagsFeature";
export const APPOINTMENT_COUNTERS_FEATURE = "appointmentCountersFeature";
export const ACCOUNTS_RECEIVABLE_SNAPSHOT_REPORT =
  "accountsReceivableSnapshotReport";
export const PREVENT_CHART_NOTES_UPDATES =
  "preventCompletedChartNotesUpdatesFeature";
export const BILLING_PAYMENTS_TAB_FEATURE = "billingPaymentsTabFeature";
export const OPEN_PATIENT_ON_APPOINTMENT_STATUS_CHANGE =
  "openPatientOnAppointmentStatusChange";
export const SHOW_CONTACT_CALL_BUTTON = "showContactCallButton";
// SN-19904. Email branding: the settings tab, the "Include email branding" checkbox, the notices and
// the branding merge tags. Off => every email surface sends exactly as before the feature.
export const EMAIL_BRANDING_FEATURE = "emailBrandingFeature";
export const AI_DIAGNOSIS_CALCULATION_FEATURE = "aiDiagnosisCalculationFeature";
export const SCHEDULING_V2_FEATURE = "schedulingV2Feature";
export const SCHEDULING_V21_FEATURE = "schedulingV21Feature";
// ENG-1981. Decides who is OFFERED Scheduling V3; each person then chooses it themselves
// (features/app-layout/scheduler-choice). Off means the classic scheduler for everyone,
// whatever they chose — the emergency brake. The V3 module itself has no LaunchDarkly import
// by design (kickoff 2026-09-14: flags become settings).
// LD key is `scheduling-v-3-feature`; this is the camelCase form the React SDK exposes
// (it camelCases every key by default, so nothing in this file is kebab-case). A second
// flag literally keyed `schedulingV3Feature` collided with it and was archived (ENG-1960).
export const SCHEDULING_V3_FEATURE = "schedulingV3Feature";
// ENG-1981. Development access to V3: a "Scheduling V3" menu entry, and /scheduling-v3 opens
// whatever the person chose. Nothing else changes — the offer, redirects and opt-out behave as
// for everyone. Read only through `useSchedulerChoice`. LD key `scheduling-v-3-dev-access`.
export const SCHEDULING_V3_DEV_ACCESS = "schedulingV3DevAccess";
// ENG-2104. The Radar rail, Sweep and the Fix resolver, plus their changes to V3's grid,
// toolbar and preview. Read only in `routes/routes.tsx` and handed to `SchedulingV3Routes` as
// a prop, because the V3 module reads no flags. Off or absent means V3 exactly as on master.
// LD key `scheduling-v3-radar`.
export const SCHEDULING_V3_RADAR_FEATURE = "schedulingV3Radar";
// ENG-2218. Offers V3's Booking Desk form layout and its "Booking desk" switch. Off means the
// classic form layout for everyone, whatever they picked; each person's pick is kept for when
// it comes back on. Read only by `scheduler-choice/booking-desk-flag-sync.component.tsx`, which
// hands it to V3 (the module itself has no LaunchDarkly import). LD key
// `booking-desk-form-feature`.
export const BOOKING_DESK_FORM_FEATURE = "bookingDeskFormFeature";
export const NTH_WEEKDAY_OF_MONTH_SCHEDULING_FEATURE =
  "nthWeekdayOfMonthSchedulingFeature";
export const CHANGE_PASSWORD = "changePassword";
export const AI_INSIGHTS_FEATURE = "aiInsightsFeature";
export const PRACTICE_USAGE_FEATURE = "practiceUsageFeature";
export const BEFORE_AND_AFTER_SUNO_FEATURE = "beforeAndAfterSunoFeature";
export const PURCHASE_AGREEMENT_DOCUMENT_FEATURE = "purchaseAgreementDocument";
export const ONLY_INCLUDE_LINE_ITEMS_WITH_PATIENT_RESPONSIBILITY =
  "onlyIncludeLineItemsWithPatientResponsibility";
export const NEW_APPOINTMENT_OUTCOME_CHANGES = "newAppointmentOutcomeChanges";
export const COMPANION_PRESENT_FIELD = "companionPresentField";
export const HEARING_AID_DEMO_FIELD = "hearingAidDemoField";
export const AUTO_UPDATE_DIAG_REF = "autoUpdateDiagRef";
export const EXPORT_DATA_FEATURE = "exportDataFeature";
export const BULK_PAYMENTS_FEATURE = "bulkPaymentFeature";
export const BUNDLES_FEATURE = "bundlesFeature";
export const SEARCH_SCHEDULE_FEATURE = "searchScheduleFeature";
export const QUICKBOOKS_DEFAULT_MAPPINGS_FEATURE = "quickbooksDefaultMappings";
export const INBOX_V2_FEATURE = "inboxV2Feature";
export const INBOX_UNREAD_FILTER_FEATURE = "inboxUnreadFilterFeature";
// ENG-2081: asks the backend to count the Inbox badge by the patient's registered clinic instead
// of the clinic a message arrived at, so the badge can no longer count a conversation the Inbox
// list is unable to show. Off => the request omits the param and the count is unchanged.
export const INBOX_UNREAD_COUNTS = "inboxUnreadCounts";
export const INBOX_CONVERSATION_TAGS_FEATURE = "inboxConversationTags";
// Patient text routing: incoming texts go to each clinic's inbox owner (`Clinic.default_assignee`)
// and the V2 Inbox gains its Mine / My clinics / Unassigned views. Effective only together with
// `INBOX_V2_FEATURE` and `practice.text_routing_active` (ENG-2223: the backend derives it from the
// clinics' inbox owners) — read them through `useTextRoutingEnabled`, never this flag inline. Off =>
// no routing request params, RestQL keys or payload keys anywhere.
export const INBOX_TEXT_ROUTING_FEATURE = "inboxTextRouting";
// Unanswered texts. With `INBOX_V2_FEATURE` (`useNeedsReplyEnabled`) ONE flag gates the Reports →
// "Unanswered Texts" report, the Inbox's red "Needs a reply" tab, the thread's Done button and the
// waiting pill on dialog rows, for every practice (ENG-2223: waiting is tracked everywhere). The AI
// column, chip and "no reply needed" switch also need `practice.ai_message_tagging_enabled`
// (`useAiMessageTaggingEnabled`). Backend ships first. Off => no new request params, RestQL keys
// (`inbox_waiting_since`, `inbox_ai_assessment`, `inbox_ai_topic`), routes or menu entries anywhere.
export const UNANSWERED_TEXTS_FEATURE = "unansweredTexts";
export const DEVICES_DASHBOARD_CLOSE_RATE_FEATURE = "devicesDashboardCloseRate";
export const BULK_TOUCHPOINTS_FEATURE = "bulkTouchpoints";
export const DEVICES_DASHBOARD_AVG_HA_SELLING_PRICE_FEATURE =
  "devicesDashboardAvgHaSellingPrice";
export const FORMS_AND_LETTERS_PRACTICE_ONLY_PDF_HEADER =
  "formsAndLettersPracticeOnlyPdfHeader";
export const BULK_TOUCHPOINTS_SMS_MESSAGES = "bulkTouchpointsSmsMessages";
export const BULK_EMAILING_FEATURE = "bulkEmailing";
export const BULK_EMAIL_SCHEDULING_FEATURE = "bulkEmailScheduling";
// Bounced-email handling: patient profile "Bounced" chip + the excluded-recipients
// note in the bulk email compose modal. Backend exclusion is always on; this flag
// only gates the UI reads so the FE can deploy ahead of the backend.
export const BOUNCED_EMAIL_HANDLING_FEATURE = "bouncedEmailHandling";
// Texts not delivered (Intercom 215476575290017): the Inbox "Texts not delivered" tab and panel,
// the conversation-row pill, the patient header phone warning + Comms chip, the profile chip and
// "set by Suno" notes, the contact-form helper text, the thread alert and the bell row for a failed
// staff text. ONE flag for all of them, like the bounced-email chip. The backend writes the state
// (landline flip, STOP tick) unconditionally; this flag only gates the UI reads. Requires Inbox V2 for
// the tab (`useTextsNotDeliveredEnabled`). Backend ships first: the RestQL read keys 400 an older API.
export const TEXTS_NOT_DELIVERED_FEATURE = "textsNotDelivered";
export const GUIDED_TOUR_FEATURE = "guidedTourFeature";
export const SURVEY_REPORT_DASHBOARD = "surveyReportDashboard";
export const ERA_CLAIMS_TAB_FEATURE = "eraClaims";
export const ASSIGNED_APPOINTMENT_TAGS_FEATURE = "assignedAppointmentTags";
export const PURCHASE_AGREEMENT_AUTH_VIA_FEATURE =
  "purchaseAgreementAuthViaFeature";
export const PRINT_MULTIPLE_CHART_NOTES_FEATURE =
  "printMultipleChartNotesFeature";
export const CHART_NOTE_COUNTS_FEATURE = "chartNoteCounts";
export const NEEDS_RESCHEDULE_FEATURE = "needsRescheduleFilter";
export const NOAH_VERIFIED_FEATURE = "noahVerifiedFeature";
export const SHOW_PATIENT_TAGS_ON_APPOINTMENT_FORM =
  "showPatientTagsOnAppointmentForm";
export const SALES_NOTES_TEMPLATES_FEATURE = "salesNotesTemplates";
export const GENERAL_LEDGER_REPORT = "generalLedgerReport";
export const APPOINTMENT_STATUS_BY_REFERRAL_SOURCE_REPORT =
  "appointmentStatusByReferralSourceReport";
export const APPOINTMENT_CREATED_BY_REFERRAL_SOURCE_REPORT =
  "appointmentCreatedByReferralSourceReport";
export const PHYSICIAN_REFERRALS_REPORT = "physicianReferralsReport";
export const SALES_MANAGEMENT_REPORT = "salesManagementReportFeature";
export const MORE_TABS_FOR_BUNDLES = "moreTabsForBundles";
export const CLEARTONE_INVENTORY_SECTION_RESTRICTION =
  "cleartoneInventorySectionRestriction";
export const NOAH_SYNC_ISSUE_FLAG = "noahSyncIssueFlag";
export const NO_PRICE_CHANGE_ON_HEARING_AIDS_SCREEN =
  "noPriceChangeOnHearingAidsScreen";
export const CLEARTONE_RESTRICTIONS = "cleartoneInventorySectionRestriction";
export const CONTROL_SCHEDULING_COLUMNS_FEATURE = "controlSchedulingColumns";
export const CHICAGOLAND_ROLES = "chicagolandRoles";
export const FAXES_PORTAL_FEATURE = "faxesSection";
export const DASHBOARD_SALE_FORECAST_BANDS_FEATURE =
  "dashboardSaleForecastBands";
export const UPLOAD_FILES_FROM_EDOCS_FEATURE = "uploadFilesFromEDocs";
export const LINE_ITEM_MODIFIERS_FEATURE = "lineItemModifiers";
export const VISIT_TRACKER_FEATURE = "visitTracker";
export const BULK_INVOICE_PRINTING_FEATURE = "bulkInvoicePrinting";
export const BILLING_REDIRECT_NAVIGATION = "billingRedirectNavigation";
export const RECURRING_APPOINTMENTS_FEATURE = "recurringAppointment";
export const AI_PROMPT_INTERFACE_FEATURE = "aiPromptInterface";
export const BULK_APPOINTMENTS_DELETE_FEATURE = "bulkAppointmentsDeleteFeature";
export const BULK_INVOICE_EMAIL_FEATURE = "bulkInvoiceEmail";
export const QUICKBOOKS_ADJUSTMENT_TYPES_FEATURE = "quickbooksAdjustmentTypes";
export const SCHEDULE_AUTOSCROLLING_FEATURE = "scheduleAutoScrolling";
export const ACCOUNTS_RECEIVABLE_REPORT_VIEW = "accountsReceivableReportView";
export const ACCOUNTS_PAYABLE_REPORT_VIEW = "accountsPayableReportView";
export const REVENUE_BY_INSURER_REPORT = "revenueByInsurerReport";
export const REVENUE_BREAKDOWN_BY_PROVIDER_REPORT =
  "revenueBreakdownByProviderReport";
export const MULTIPLE_USERS_IN_CLINIC_EVENT_FEATURE =
  "multipleUsersInClinicEventFeature";
export const MEDICAL_SCRIBE_FEATURE = "medicalScribe";
// After Visit Summary letter (Intercom 215475744511616): the appointment-page card, the chart-note
// button, the view-and-send dialog, the scribe-dialog tab, and the AfterVisitSummary template type in
// settings. Server-side auto-generation follows the practice's Ambient Scribe subscription.
export const AFTER_VISIT_SUMMARY_FEATURE = "afterVisitSummary";
export const SCRIBE_INSIGHTS_FEATURE = "scribeInsights";
export const AMBIENT_SCRIBE_TEMPLATE_TYPE_TEMPLATE =
  "ambientScribeTemplateTypeTemplate";
export const SALE_TOTAL_COLUMN_FOR_PAYMENTS_REPORT =
  "saleTotalColumnForPaymentsReport";
export const PAYMENT_REPORT_PRODUCT_TYPE_COLUMNS =
  "paymentReportProductTypeColumns";
// Card Brand / Card Last 4 on the payment surfaces. Gates the COLUMNS, the form inputs, the
// RestQL read queries AND the write payload keys — flag-off must not request or send the fields,
// so the FE can ship before the backend without 400-ing (`ValidateUnknownFieldsMixin`).
export const PAYMENT_CARD_BRAND_LAST4 = "paymentCardBrandLast4";
export const ADJUSTMENT_REPORT_PRODUCT_FIELDS = "adjustmentReportProductFields";
export const CLICKING_ON_AUDIOGRAM_TO_COLLECT_MEASUREMENT =
  "clickingOnAudiogramToCollectMeasurement";
export const CURRENT_SALE_QUICK_ACTIONS = "currentSaleQuickActions";
export const INVOICE_HISTORY_TAB_FEATURE = "invoiceHistoryTab";
// The single-invoice Print/Email dialog laid out in sections (header, items, totals, end of the
// invoice) so every option fits without scrolling. Same fields, labels and submit. Off => today's
// single-column dialog, unchanged.
export const INVOICE_PRINT_DIALOG_SECTIONED = "invoicePrintDialogSectioned";
export const CLAIM_ERA_NOTES_TAB_FEATURE = "claimEraNotesTab";
// Gates the "Include signature line" checkbox in the single-invoice print dialog and the bulk
// print modal (SN-19192). Off => no checkbox, invoices render exactly as today. Deliberately
// placed here (billing cluster) rather than appended at the tail, where concurrent flag
// additions on master collide on every merge.
export const INVOICE_PATIENT_SIGNATURE_LINE = "invoicePatientSignatureLine";
// SN-19829: "Payments on invoice" (Itemized / Net total / Hide) for the invoice V2 PDF: a radio
// group in the single-invoice Print/Email dialog and a toggle on the invoice page. Net total prints
// "Total Paid by Patient" (payments minus refunds) instead of the payment and refund rows. Off =>
// neither control renders, a payments_display value in state or the URL is ignored, and the PDF is
// byte-identical. Frontend only. A new LD flag starts on, so create it serving false.
export const INVOICE_NET_PAYMENTS = "invoiceNetPayments";
// ENG-2326 kill switch: the invoice V2 PDF is fitted onto a real, centered US Letter page
// (fitPdfPagesToLetter) instead of react-pdf's 14.7"x20.8" dpi-128 page, which Chrome prints at
// actual size and cuts off. Off => the blob is published exactly as today. Frontend only. A new
// LD flag starts on, so check `on` + fallthrough in every environment after creating it.
export const INVOICE_PDF_LETTER_PAGE_SIZE = "invoicePdfLetterPageSize";
export const WEB_SCHEDULER_APPOINTMENTS_FILTER =
  "webSchedulerAppointmentsFilter";
export const RECURRING_PAYMENTS_FEATURE = "recurringPayments";
export const PERSONAL_EVENTS_REPORT = "personalEventsReport";
export const AUDIOLOGY_REPORT_CLEAN_HTML = "audiologyReportCleanHtml";
export const BULK_PRINT_EMAIL_STATEMENTS = "bulkPrintEmailStatements";
export const NO_INVOICE_BUTTON = "noInvoice";
export const REMOVE_EXCLUDE_FROM_APPOINTMENT_OUTCOMES =
  "removeExcludeFromAppointmentOutcomes";
export const APPLY_DEFAULT_AUDIOLOGY_SETTINGS = "applyDefaultAudiologySettings";
export const BILLING_TABS_TOTALS = "billingTabsTotals";
export const ADD_MULTIPLE_REFERRING_PHYSICIANS_TO_PATIENT =
  "addMultipleReferringToPatient";
export const CAMPAIGN_CLEAN_AND_CHECK = "campaignCleanAndCheck";
export const CAMPAIGN_THREE_YEAR_HEARING_EVALUATION =
  "campaignThreeYearHearingEvaluation";
export const CAMPAIGN_SERVICE_PLAN_EXPIRATION = "campaignServicePlanExpiration";
export const RECURRING_PAYMENTS_REPORT = "recurringPaymentsReport";

export const PAYMENTS_REPORT_SUMMARY_FEATURE = "paymentsReportSummary";
export const ALLOW_PAYMENT_SOURCE_HEARING_AIDS_SALE =
  "allowPaymentSourceHearingAidsSale";
export const ADD_HEARING_AIDS_TO_INVOICE = "addHearingAidsToInvoice";
export const SPLIT_HEARING_AID_INVOICE_BUTTONS =
  "splitHearingAidInvoiceButtons";
export const AUDIOLOGY_REPORT_PDF_IFRAME_PREVIEW =
  "audiologyReportPdfIframePreview";
export const PATIENT_BULK_PAYMENTS = "patientBulkPayments";
export const BULK_PAYMENT_ADJUSTMENTS = "bulkPaymentAdjustments";
export const BULK_PAYMENT_SINGLE_ACCOUNT_CHARGE =
  "bulkPaymentSingleAccountCharge";
export const MULTI_INVOICE_TERMINAL_PAYMENTS = "multiInvoiceTerminalPayments";
export const MULTIPLE_CPT_CODES_FEATURE = "multipleCptCodesFeature";
export const BULK_ASSIGN_CPT_CODES_FEATURE = "bulkAssignCptCodes";
export const LEADS_UI = "leadsUi";
export const LEAD_CAMPAIGNS_CALL_NODE = "leadCampaignsCallNode";
/** SN-19946: Performance + Messages tabs, send totals on the list, and Leads email branding settings. */
export const LEAD_CAMPAIGNS_PERFORMANCE = "leadCampaignsPerformance";
/** ENG-2572: Leads → Settings → Webhooks (the Google Ads setup page). Off when the flag is missing. */
export const LEADS_WEBHOOKS = "leadsWebhooks";
/** ENG-2572: the Webhooks → Logs page. Nested under Webhooks, so it also needs LEADS_WEBHOOKS. */
export const LEADS_WEBHOOK_LOGS = "leadsWebhookLogs";
export const AI_SUMMARY_FEATURE = "aiSummaryFeature";
export const AI_SUMMARY_OVERVIEW_TYPE = "aiSummaryOverviewType";
export const AI_SUMMARY_REPORT_TYPE = "aiSummaryReportType";
export const AI_SUMMARY_ONBOARDING_TYPE = "aiSummaryOnboardingType";
export const AI_SUMMARY_VISIT_TYPE = "aiSummaryVisitType";
export const AI_SUMMARY_PRODUCT_TYPE = "aiSummaryProductType";
export const SCHEDULE_VIEW_IN_PATIENT_HEADER = "scheduleViewInPatientHeader";
export const TAG_TRANSFER_ON_RESCHEDULE_FEATURE = "tagTransferOnReschedule";
export const DAY_SHEET = "scheduleViewChartNoteAndAudiologyStatus";
export const BALANCES_DUE_WITH_COUNTS_ACCOUNTS_RECEIVABLE_REPORT =
  "balancesDueWithCountsAr";
export const RESYNC_TERMINAL_PAYMENT_REQUESTS = "reSyncTerminalPaymentRequests";
export const GOOGLE_CALENDAR_SYNC_FEATURE = "googleCalendarSyncFeature";
export const GOOGLE_CALENDAR_TWO_WAY_SYNC = "googleCalendarTwoWaySync";
export const APPOINTMENT_BLOCK_FIXED_POSITION = "appointmentBlockFixedPosition";
export const EXPAND_SCHEDULING_APPOINTMENTS = "expandSchedulingAppointments";
export const HEARING_AIDS_NAVIGATE_TO_SALE_PAGE =
  "hearingAidsNavigateToSalePage";
export const WORD_PROCESSOR_FORMS = "wordProcessorForms";
export const CAMPAIGN_WEEK_9_FOLLOW_UP = "campaignWeek9FollowUp";
export const SIGN_AND_UPLOAD_APPOINTMENT_FORMS =
  "signAndUploadAppointmentForms";
export const BULK_TOUCHPOINTS_APPOINTMENTS_REPORT_FEATURE =
  "bulkTouchpointsAppointmentsReport";
export const BULK_TASKS_FEATURE = "bulkTasksFeature";
export const BULK_DEACTIVATE_PATIENTS_FEATURE =
  "bulkDeactivatePatientsFromPatientsReport";
export const UPLOAD_CUSTOM_AMBIENT_SCRIBE_AUDIO =
  "uploadCustomAmbientScribeAudio";
export const PATIENT_BALANCE_NORMALIZING = "patientBalanceNormalizing";
export const PURCHASE_AGREEMENT_TEMPLATES_SECTION =
  "purchaseAgreementTemplatesSection";
export const MOVE_ITEMS_BETWEEN_INVOICES = "moveItemsBetweenInvoices";
export const PDF_NATIVE_TABLES = "pdfNativeTables";
export const PDF_PRINTABLE_TABLE_LAYOUT_FIXES = "pdfPrintableTableLayoutFixes";
export const APPPOINTMENT_BLOCK_FULFILLMENT_FEATURE =
  "appointmentBlockFulfillmentFeature";
export const FIVE_KEYS_INTEGRATION = "fiveKeysIntegration";
export const MANUAL_SAVE_FOR_AUDIO_REPORTS = "manualSaveForAudiologyReports";
export const ALLOW_ENTERING_CANCELLATION_REASON =
  "allowEnteringACancellationReason";

export const DOB_REQUIRED_FOR_POLICY_HOLDER = "makeDobRequiredForPolicyHolder";
export const BE_API_URLS_FLAG = "beApiUrls";
export const NEW_ERROR_SCREEN = "newErrorScreen";
export const HIDE_TAX_ID = "hideTaxId";
export const ENFORCE_DELIVERY_BEFORE_READY_TO_BILL =
  "enforceDeliveryBeforeReadyToBill";
export const COMMISSIONS_REPORT = "commissionsReport";
export const COMMISSIONS_BREAKDOWN_REPORT = "commissionsBreakdownReport";
export const COMMISSION_PLANS_FEATURE = "commissionPlans";
export const PROFITABILITY_REPORT = "profitabilityReport";
export const TOTAL_SALES_FINANCES_REPORT = "totalSalesFinancesReport";
export const PATIENT_CPT_REPORT = "patientCptReport";
export const PAYWALL_BYPASS = "paywallBypass";
export const HIDE_INVENTORY_SECTIONS = "hideInventorySections";
export const USE_PREFERRED_PROVIDER_FOR_INVOICE =
  "usePreferredProviderForInvoice";
export const BULK_ONLINE_PAYMENT_REQUESTS = "bulkOnlinePaymentRequests";
export const MARKETPLACE_FEATURE = "marketplaceFeature";
export const WEB_SCHEDULER_APPOINTMENT_TYPES_ENHANCEMENTS =
  "webSchedulerAppointmentTypesEnhancements";
export const APPOINTMENT_TYPE_CLINIC_AVAILABILITY =
  "appointmentTypeClinicAvailability";
export const WEB_SCHEDULER_DEPOSIT_ENABLED = "webSchedulerDepositEnabled";
export const WEB_SCHEDULER_LIMIT_TO_PROVIDERS = "webSchedulerLimitToProviders";
// ENG-1912: staff-side carry-over of the web-booking address + the admin "require address" toggle.
export const WEB_SCHEDULER_REQUIRE_PATIENT_ADDRESS =
  "webSchedulerRequirePatientAddress";
// SN-19962: extra online schedulers per location and question steps. Turn on only after backend
// PRs A and B and both widgets are live; flag off, every surface and payload matches master.
export const WEB_SCHEDULER_CONFIGURATIONS = "webSchedulerConfigurations";
export const PAYMENT_REQUEST_FEE = "paymentRequestFee";
export const TILLED_PAYMENT_METHODS_CONFIGURATION =
  "tilledPaymentsMethodsConfiguration";
export const ONLINE_SCHEDULED_APPOINTMENTS_REPORTS =
  "onlineScheduledAppointmentsReports";
export const VERTICAL_SOUTHWESTERN_LIMITATIONS =
  "onlyAdministratorsCanSetSchedule";

export const DEEPGRAM_SPEECH_TO_TEXT = "deepGramSpeechToText";
export const PATIENTS_PAGE_X_GRID = "patientsPageXGrid";
export const NOAH_DEVICES_DISPLAY = "noahDevicesDisplay";
export const NOAH_PATIENT_SEARCH_FEATURE = "noahPatientSearchFeature";
export const PATIENT_USER_VIEWS = "patientUserViews";
// LD key: appointment-user-views (camelCased by the SDK). Gates the Saved Views widget on the
// Appointments report and its Discarded variant. Off => the widget never renders, no
// custom-filter-view requests are issued, and the report behaves exactly as it did before.
export const APPOINTMENT_USER_VIEWS = "appointmentUserViews";
export const VOB_REQUEST_FEATURE = "vobRequest";
export const DISPLAY_SUPERVISING_PROVIDER = "displaySupervisingProvider";
export const TAG_ACTIONS_FEATURE = "tagActionsFeature";
export const HIDE_PERSONAL_AND_CLINIC_EVENT_OPTION_FOR_USERS =
  "hidePersonalClinicEventOptionForUsers";
export const PODIUM_INTEGRATION = "podiumIntegration";
export const QBO_LINK_EXISTING_INVOICE_FEATURE = "qboLinkExistingInvoices";
export const DRAG_AND_DROP_EMAIL_BUILDER = "dragAndDropEmailBuilder";
export const QBO_ICON_ON_PATIENT_PROFILE = "qboIconOnPatientProfile";
export const QBO_BULK_SYNC_FEATURE = "qboBulkSync";
export const QBO_SYNC_EXCLUSION_RULES_FEATURE = "qboSyncExclusionRules";
export const SCAN_MULTIPLE_FILES_AT_ONCE = "scanMultipleFilesAtOnce";
export const SERIAL_NUMBER_HISTORY_SEARCH = "serialNumberHistorySearch";
export const CENTRALIZED_APPOINTMENT_TEXT_EMAIL_TEMPLATES =
  "centralizedAppointmentTextEmailTemplates";
export const ALLOW_EDIT_USER_EMAIL = "allowEditUserEmail";
export const WATERLOO_AUDIOLOGY_CONTACT_INFORMATION =
  "waterlooAudiologyContactInformation";
export const QUICKBOOKS_DASHBOARD_FEATURE = "quickbooksDashboard";
export const ERA_NEGATIVE_ADJUSTMENTS = "eraNegativeAdjustments";
export const SUPPORT_NEGATIVE_ADJUSTMENTS = "supportNegativeAdjustments";
export const SHOW_ALL_CLINICS = "showAllClinics";
export const DEDICATED_SLOT_WIDTH = "dedicatedSlotWidth";
export const DISABLE_REPORTS_AND_DASHBOARD = "disableReportsAndDashboard";
export const OPTIMIZE_AR_QUERY = "optimizeArQuery";
export const REPORT_EXECUTION_GATE_FEATURE = "reportExecutionGate";
// ENG-2126. Replaces the /calls/overview tile grid with the Call Intelligence
// page (call content flow, follow-up queue, conversion funnel); the legacy
// widgets stay reachable under its "Volume" view. OFF keeps the ENG-1931 page.
// Its drill-through links open the workspace's insight modes, so serve it true
// only where `callInsights` (below) is also true.
export const CALL_INTELLIGENCE_DASHBOARD_FEATURE = "callIntelligenceDashboard";
export const ADD_PATIENT_HEADER_ON_DOCS_AND_LETTERS_FEATURE =
  "addPatientHeaderOnDocsAndLetters";
export const TILLED_PAYOUT_RECONCILIATION = "tilledPayoutReconciliation";
export const AMBIENT_SCRIBE_CUSTOM_TEMPLATES = "ambientScribeCustomTemplates";
export const INCLUDE_QR_CODES_IN_INVOICES = "includeQrCodesInInvoices";
export const AUTO_GENERATE_INVOICES_FOR_SUPPLIES =
  "autoGenerateInvoicesForSupplies";
export const ZOOM_TELEHEALTH_INTEGRATION = "zoomTelehealthIntegration";
export const HL7_INTEGRATION = "hl7Integration";
export const HIDE_GLOBAL_TAGS = "hideGlobalTags";
export const SAVE_CARD_ON_FILE = "saveCardOnFile";
export const CHART_NOTE_DATE_FIELD = "chartNoteDateField";
// ENG-2278. Asks the backend for `can_discard` on chart notes, so an Appointment Note stays
// deletable after a No-Show / Cancel / Reschedule. Gated because an older backend rejects the
// unknown RestQL key.
export const APPOINTMENT_NOTE_DISCARD_RULE = "appointmentNoteDiscardRule";
export const APPOINTMENT_TYPE_DEFAULT_CHART_NOTE =
  "appointmentTypeDefaultChartNote";
export const AMBIENT_SCRIBE_GENERATE_TEMPLATE = "ambientScribeGenerateTemplate";
export const AMBIENT_SCRIBE_TEMPLATE_WIZARD = "scribeTemplateWizard";
// SN-19067. Gates Ambient Scribe template TYPES (Chart Note / Audiology Report).
// Not to be confused with AMBIENT_SCRIBE_TEMPLATE_TYPE_TEMPLATE above, which gates the
// appointment-type → template link. The backend rejects the new `type` write key and the
// new nested `?query=` objects outright, so the OFF path must stay byte-identical.
export const AMBIENT_SCRIBE_TEMPLATE_TYPES = "ambientScribeTemplateTypes";
export const AUTO_SET_REFERRAL_AND_SUB_REFERRAL_SOURCES =
  "autoSetReferralAndSubReferralSources";
export const CONFIGURABLE_APPOINTMENT_CHECKLIST =
  "configurableAppointmentChecklist";
export const CLAIM_MD_ELIGIBILITY_VERIFICATION =
  "claimMdEligibilityVerification";
export const CLAIM_MD_ELIGIBILITY_DETAIL = "claimMdEligibilityDetail";
// Verify a policy against Claim MD from the screens that CREATE a policy (New Patient wizard,
// Add Policy page) rather than only from a saved policy's detail page. Deliberately separate
// from CLAIM_MD_ELIGIBILITY_VERIFICATION so turning this on does not depend on, or disturb,
// the policy-page button that is already live for other practices.
export const CLAIM_MD_VERIFY_ON_POLICY_CREATION =
  "claimMdVerifyOnPolicyCreation";
// ENG-2516 (LD `claim-md-eligibility-error-guidance`): a failed verify stays on screen as one error block
// on both verify surfaces, led by the backend's message / next step (ENG-2515). Off = the policy page's
// auto-hiding snackbar and the wizard's fixed member-ID hint, exactly as before.
export const CLAIM_MD_ELIGIBILITY_ERROR_GUIDANCE =
  "claimMdEligibilityErrorGuidance";
export const BULK_REGION_ASSIGNMENT = "bulkRegionAssignment";
export const CLINIC_STOCK_ORDER_TRACKING = "clinicStockOrderTracking";
export const ENABLE_UNDISCARD_ACTION = "enableUndiscardAction";
export const ENABLE_MOVE_REFUND = "enableMoveRefund";
// Invoice History also lists payments and refunds that moved OFF the invoice. That lookup reads
// the patient's whole payment/refund audit history, so it sits behind a flag that can switch it off.
export const INVOICE_HISTORY_INCLUDE_MOVES = "invoiceHistoryIncludeMoves";
export const SYNC_INTAKE_FORM_SUBMISSIONS_FEATURE = "syncIntakeFormSubmissions";
/**
 * Manage the forms on an already-sent intake form request (Intercom 215475694260666):
 * per-form Cancel on pending steps, "Add Forms" to an existing request, and the per-form
 * requested/added/cancelled audit line. Backend ships first (cancelled_at/cancelled_by +
 * submission_ids on the cancel action).
 */
export const MANAGE_INTAKE_FORM_REQUEST_FORMS_FEATURE =
  "manageIntakeFormRequestForms";
export const SAVE_ALL_INTAKE_FORMS_TO_EDOCS_FEATURE =
  "saveAllIntakeFormsToEdocs";
/**
 * Collapse the intake form request's Send History band behind a "Send history (N)" toggle, with a
 * one-line "Last sent …" summary beside it and a "View history" link in the Last Sent column.
 * Off keeps the band always visible, as before. Frontend-only.
 */
export const INTAKE_FORM_SEND_HISTORY_COLLAPSED_FEATURE =
  "intakeFormSendHistoryCollapsed";
/**
 * Remember who saved each submitted intake form to E-Docs and when: the "In E-Docs" chip and
 * stamp per form, "Save again" (outlined, confirmed) once a form is saved, the unsaved-aware
 * "Save All" label and menu, and the per-request "N of M saved" line. Backend ships first: with the
 * flag on the frontend records every save through `POST .../intake-form-requests/{id}/edocs-saves/`,
 * which an older backend does not have.
 */
export const INTAKE_FORM_EDOCS_SAVE_TRACKING_FEATURE =
  "intakeFormEdocsSaveTracking";
/**
 * "Fill in Office" on the patient's Onboardings tab: open an intake form request for the patient to
 * fill in at the clinic without logging in to the portal, in a new tab or by QR code, with live
 * progress and the per-request in-office audit band. Backend ships first
 * (`/intake-form-requests/{id}/in-office-sessions/` + the portal's `/in-office/:code` page).
 */
export const IN_OFFICE_INTAKE_FORMS_FEATURE = "inOfficeIntakeForms";
export const DO_NOT_CONTACT_WARNINGS_FEATURE = "doNotContactWarnings";
export const CLINIC_STAFF_SCHEDULE = "clinicStaffSchedule";
export const AMBIENT_SCRIBE_PROCESSING_EVENTS = "ambientScribeProcessingEvents";
export const AMBIENT_SCRIBE_VERIFIED_MICROPHONES =
  "ambientScribeVerifiedMicrophones";
export const AMBIENT_SCRIBE_PAUSED_FEATURE = "ambientScribePostpone";
export const AMBIENT_SCRIBE_STILL_RECORDING_PROMPT =
  "ambientScribeStillRecordingPrompt";
export const AMBIENT_SCRIBE_FORMATTED_TRANSCRIPT =
  "ambientScribeFormattedTranscript";
/**
 * Scribes list: the appointment-type / template / chart-note columns and filters, plus the
 * month-to-date date-range default.
 *
 * Load-bearing beyond the usual rollout control. The new columns are RestQL fields, and naming
 * one against a backend that predates them fails the WHOLE list read with a 400 (the screen goes
 * blank, not degraded) — so this must stay off until the backend side has deployed. Note LD
 * serves a new boolean flag's *fallthrough* variation, which is `true`, regardless of
 * `offVariation`: creating the flag is not the same as creating it off. Verify with
 * `get-flag ambientScribeListFilters --env <env>` before relying on it.
 */
export const AMBIENT_SCRIBE_LIST_FILTERS = "ambientScribeListFilters";
export const PROCESS_CREDIT_DEBIT_CARD_TOGGLE = "processCreditDebitCardToggle";
export const GRAVITY_CREDIT_DEPOSITS = "gravityCreditDeposits";
export const ENABLE_TERMINAL_CREDIT = "enableTerminalCredit";
export const EXPOSE_CLAIM_MD_USER_DETAILS = "exposeClaimMdUserDetails";
export const ENABLE_STATE_LICENSES = "enableStateLicenses";
export const STATE_LICENSE_CLAIMS = "stateLicenseClaims";
export const MANUFACTURER_ALLOWLIST_FEATURE = "manufacturerAllowlist";
/**
 * SN-20044: the catalog-entry pickers send `practice_filtered=true` to `/master-products/`, so a practice
 * with manufacturer filtering on is offered only hearing aids from its allowed manufacturers. Off ⇒ the
 * request is unchanged. A backend predating the param ignores it.
 */
export const MASTER_PRODUCT_ALLOWLIST_FILTER_FEATURE =
  "masterProductAllowlistFilter";
export const AUDIOGRAM_LOGARITHMIC_AXIS = "audiogramLogarithmicAxis";
export const SHOW_SPEECH_AUDIOMETRY_SCORES_ON_LAST_AUDIO =
  "showSpeechAudiometryScoresOnLastAudio";
export const INVOICE_EXTENDED_LINE_ITEMS_FEATURE =
  "invoiceExtendedLineItemsFeature";
export const AI_SCHEDULING_ASSISTANT = "sunoConcierge";
export const PURCHASE_AGREEMENT_FOOTER_SIGNER = "purchaseAgreementFooterSigner";
export const CUSTOM_FORM_SIGNER_LICENSE_PICKER =
  "customFormSignerLicensePicker";
export const APPOINTMENT_TYPE_INTERVAL_SETTING =
  "appointmentTypeIntervalSetting";
export const TABBED_CHART_NOTE_REDESIGN = "tabbedChartnoteRedesign";
export const ROOM_BOOKING_DURATION_OVERRIDE = "roomBookingDurationOverride";
export const HIDE_QUICK_FILTER_COUNTS = "hideProductCounts";
// Pilot gate for the single-request Clinic Stock counts endpoint; off falls back to the legacy 8-call fan-out.
export const CLINIC_STOCK_BULK_COUNTS_ENABLED = "clinicStockBulkCountsEnabled";
// Gates the /patient-products/counts/ bulk endpoint for the Patient Devices quick-filter chips.
export const PATIENT_DEVICES_BULK_COUNTS_ENABLED =
  "patientDevicesBulkCountsEnabled";
export const OPTIMIZED_ASSIGNED_TAGS_ENDPOINT = "optimizedAssignedTagsEndpoint";
export const PATIENT_PORTAL_SHARING_V2 = "patientPortalSharingV2";
export const ACTIVE_VISIT_DRAWER = "activeVisitDrawer";
export const PRICE_FIELD_INPUT_V2 = "priceFieldInputV2";
export const OVERLAY_MULTIPLE_AUDIOGRAMS = "overlayMultipleAudiograms";
export const APPOINTMENT_PAGE_REDESIGN = "appointmentPageRedesign";
export const USERS_LIST_V2 = "usersListV2";
export const ENABLE_SSO_INVITATIONS = "enableSsoInvitations";
export const PATIENT_BILLING_CSV_DOWNLOAD = "patientBillingCsvDownload";
export const PAYMENTS_REPORT_EXCLUDE_REFUNDS_AND_CREDITS_BY_DEFAULT =
  "paymentsReportExcludeRefundsAndCreditsByDefault";
export const HIDE_COST_FIELD_BY_DEFAULT = "hideCostFieldByDefault";
export const ACCESS_TO_COSTS_ENABLED = "accessToCostsEnabled";
export const CLINIC_STOCK_CSV_DOWNLOAD_ENABLED =
  "clinicStockCsvDownloadEnabled";
export const DASHBOARD_WIDGETS_FEATURE = "dashboardWidgets";
export const FAX_CENTER_PATIENT_WIZARD = "faxCenterPatientWizard";
export const BLOCK_DRAG_DROP_FEATURE = "blockDragDropFeature";
export const NO_DEFAULT_PAYMENT_METHOD = "noDefaultPaymentMethod";
export const REPORT_SIGNING_PERMISSIONS = "reportSigningPermissions";
export const BUNDLE_MODIFIERS_FEATURE = "bundleModifiers";
export const CLAIM_MD_NPI_SELECTOR = "claimMdNpiSelector";
export const CURRENT_APPOINTMENT_MERGE_TAG = "currentAppointmentMergeTag";
export const CLINICAL_MERGE_TAGS = "clinicalMergeTags";
// SN-19877: merge tags matching Anvil's aliases (LD `anvil-merge-tag-parity`). Also gates the patient
// query's `primary_medicare_insurance_policy` key, which needs the backend field deployed first.
export const ANVIL_MERGE_TAG_PARITY = "anvilMergeTagParity";
// ENG-2492: every purchase agreement value as its own merge tag (LD `digital-form-tags-purchase-agreement`).
// Also asks the invoice query for the line keys those tags read.
export const DIGITAL_FORM_TAGS_PURCHASE_AGREEMENT =
  "digitalFormTagsPurchaseAgreement";
// ENG-2493 / ENG-2494: every order-form and repair-form value as its own merge tag (LD
// `digital-form-tags-order`, `digital-form-tags-repair`). With either on, that surface's Digital Forms also
// fill Clinic.* and Practice.* from the form's own clinic (ENG-2491).
export const DIGITAL_FORM_TAGS_ORDER = "digitalFormTagsOrder";
export const DIGITAL_FORM_TAGS_REPAIR = "digitalFormTagsRepair";
// ENG-2494: the repair form's new Request.* tags on the Exchange and Loss & Damage forms, each under its own flag (LD
// `digital-form-tags-exchange`, `digital-form-tags-loss-damage`).
export const DIGITAL_FORM_TAGS_EXCHANGE = "digitalFormTagsExchange";
export const DIGITAL_FORM_TAGS_LOSS_DAMAGE = "digitalFormTagsLossDamage";
// ENG-2499: Digital Forms on Appointment Forms, with the Appointment tag group filled from the printed
// appointment (LD `digital-form-tags-appointment-forms`). Only with HTML_FORMS_FEATURE on too.
export const DIGITAL_FORM_TAGS_APPOINTMENT_FORMS =
  "digitalFormTagsAppointmentForms";
export const CLAIM_SCRUBBING_POC = "claimScrubbingPoc";
export const CLAIM_SUPPORTING_DOCUMENTS_UPLOAD =
  "claimSupportingDocumentsUpload";
// Corrected claims / HCFA Box 22 (refile dialog, wizard section, Type column,
// Claim.MD response viewer + the backend-first RestQL keys they read)
export const CORRECTED_CLAIMS_BOX22_FEATURE = "correctedClaimsBox22";
export const SALE_COST_COLUMN_ENABLED = "saleCostColumnEnabled";
export const EDIT_INVOICE_ENHANCEMENTS = "editInvoiceEnhancements";
export const COLLECT_PAYMENT_FROM_INVOICE_FEATURE =
  "collectPaymentFromInvoiceFeature";
export const ENABLE_CLINIC_STOCK_TAGS = "enableClinicStockTags";
export const OUTSIDE_PURCHASE_TAG = "outsidePurchaseTag";
export const AUDIOLOGY_REPORTS_FEATURE = "audiologyReports";
export const SECONDARY_INSURANCE_AUTOPOPULATE =
  "secondaryInsuranceAutopopulate";
export const EXCHANGE_ALL_DEVICE_TYPES = "exchangeAllDeviceTypes";
export const EXCHANGE_FORM_GENERATION = "exchangeFormGeneration";
// Gates the explanatory helper UX layered onto the device exchange flow (dialog intro
// banner, field helper text, inline disabled-row reasons, wizard stepper, old/new device
// labeling, richer success snackbar). Copy/color/read-only display only — no behavior.
export const EXCHANGE_FLOW_HELPER_UX = "exchangeFlowHelperUx";
export const RETURN_FLOW_HELPER_UX = "returnFlowHelperUx";
export const AVAILABILITY_BLOCK_COLORS_FEATURE = "availabilityBlockColors";
export const SYNC_SALE_PAYMENTS_TO_TILLED = "syncSalePaymentsToTilled";
export const PATIENT_AUTOMATION_OPT_OUT = "patientAutomationOptOut";
export const SCHEDULING_BOOTSTRAP_TIMEOUT_MS = "schedulingBootstrapTimeoutMs";
export const PA_DIALOG_YIELD_PAINT_V1 = "paDialogYieldPaintV1";
export const PAYMENT_RECEIPT_FEATURE = "paymentReceiptEnabled";
export const PRODUCT_SEARCH_LOADING_STATE_V1 = "productSearchLoadingStateV1";
export const PAYMENT_TERMINALS_FEATURE = "paymentTerminals";
export const CHUNK_LOAD_RECOVERY = "chunkLoadRecovery";
export const PATIENT_PRONOUNS_FEATURE =
  "addPatientPronounsFieldProfileHeaderAndMergeTags";
// SN-19749. Structured preferred language on the profile, the new-patient wizard and the header
// (non-English only). Gates both the RestQL read keys and the write payload keys.
export const PATIENT_PREFERRED_LANGUAGE_FEATURE = "patientPreferredLanguage";
export const INSURANCE_POLICY_READ_VIEW_REDESIGN =
  "insurancePolicyReadViewRedesign";
export const INSURANCE_POLICY_TWO_COLUMN_LAYOUT =
  "insurancePolicyTwoColumnLayout";
export const INSURANCE_POLICY_AUDIT_FIELDS = "insurancePolicyAuditFields";
export const HEARING_AID_BENEFIT_CALCULATOR = "hearingAidBenefitCalculator";
export const PRACTICE_FORM_DEFAULTS_FEATURE = "practiceFormDefaultsFeature";
export const CATALOG_CSV_UPLOAD_FEATURE = "catalogCsvUploadFeature";
// ENG-1911 phase 2: three-step upload flow (Upload -> Review changes -> Done)
// with .xlsx support and a server dry-run preview before anything is written.
export const CATALOG_CSV_UPLOAD_PREVIEW_FEATURE =
  "catalogCsvUploadPreviewFeature";
// ENG-1911 phase 4: rows without a Product ID in a catalog upload are matched
// against the hearing-aid Master List and offered as new products to add.
export const CATALOG_CSV_CREATE_ON_UPLOAD_FEATURE =
  "catalogCsvCreateOnUploadFeature";
export const BACKFILL_EDOC_FOLDERS_FEATURE = "backfillEdocFoldersFeature";
export const RECONNECT_PATIENT_PRODUCT_INVENTORY =
  "reconnectPatientProductInventory";
export const PATIENT_PRODUCT_PREVIEW_MODAL = "patientProductPreviewModal";
export const INBOX_MESSAGING_HEALTH = "inboxMessagingHealth";
export const FORCE_SSO_TOGGLE_FEATURE = "forceSsoToggleFeature";
export const IMPLEMENTATION_HUB_FEATURE = "implementationHubFeature";
export const STAFF_TASK_COLORS_FEATURE = "staffTaskColors";
// LD key: default-preferred-communication-method-for-new-patients (camelCased by the SDK)
export const DEFAULT_PREFERRED_COMMUNICATION_METHOD_FEATURE =
  "defaultPreferredCommunicationMethodForNewPatients";
// LD key: topaz-signature-pad (camelCased by the SDK). Off => the signing
// dialog renders exactly as it did before the Topaz provider existed.
export const TOPAZ_SIGNATURE_PAD_FEATURE = "topazSignaturePad";
// Report Finder on the Patients report. Off by default — this is the only gate on the
// feature, so the endpoint is unreachable from the UI until the flag is turned on.
export const REPORT_FINDER = "reportFinder";
// LD key: otoscopy-audiology-reports (camelCased by the SDK). Gates the Otoscopy section on
// the audiology report: the editor, the preview block and the "Otoscopy" report-preference
// toggle. Off => the section never mounts, so no otoscopy values are read or written and the
// report behaves exactly as it did before the feature existed.
export const OTOSCOPY_AUDIOLOGY_REPORTS = "otoscopyAudiologyReports";
// LD key: speech-word-recognition-annotations (camelCased by the SDK). Gates the optional
// free-text annotation fields on the Speech/Word Recognition section of the audiology report
// (one under Speech Audiometry, one under Word Recognition) and the `annotation` key in the
// section's save payload. Off => the fields never render and the PATCH body is byte-identical
// to before the feature existed. The backend columns ship unconditionally, and the report GET
// requests these sub-reports as whole objects, so the READ side needs no gating. Preview/PDF
// render an annotation only when one is stored, so flag-off output is unchanged.
export const SPEECH_WORD_RECOGNITION_ANNOTATIONS_FEATURE =
  "speechWordRecognitionAnnotations";
// LD key: speech-word-recognition-annotations-below-tables (camelCased by the SDK). Prints each
// Speech/Word Recognition annotation as a full-width line under its table, in both PDF templates,
// the report preview and the patient header's Last Audiogram hover, instead of on the
// Presentation/List header row, where a long word list squeezed it to ~0px (SN-20073). Off =>
// the header-row layout, unchanged. A report with no annotation lays out the same either way.
export const SPEECH_WORD_RECOGNITION_ANNOTATIONS_BELOW_TABLES_FEATURE =
  "speechWordRecognitionAnnotationsBelowTables";
// LD key: template-preview (camelCased by the SDK). Gates the Preview button on the
// word-processor template editors (Settings → Templates, Settings → Purchase Agreements).
// Off => the button never renders and the preview dialog never mounts, so the editors
// behave exactly as they did before the feature existed.
export const TEMPLATE_PREVIEW_FEATURE = "templatePreview";
// LD key: card-on-file-onboarding-step (camelCased by the SDK). Gates the "Add a credit card on
// file" step in the New Form Submission Request modal. Off => the row never renders and the
// `submission_type` key never reaches the payload, so the request body is byte-identical to what
// a backend without ENG-1569 accepts.
export const CARD_ON_FILE_ONBOARDING_STEP_FEATURE = "cardOnFileOnboardingStep";
// LD key: insurance-policy-notes-in-picker (camelCased by the SDK). Gates the policy
// `notes` line in the insurance-policy pickers (billing sale form, HCFA wizard, and the
// other shared-picker call sites). Off => no node is rendered, so the DOM is identical
// to what it was before the feature existed.
export const INSURANCE_POLICY_NOTES_IN_PICKER = "insurancePolicyNotesInPicker";
// LD key: scribe-follow-ups (camelCased by the SDK). SN-19269. Gates the Follow Ups page, its
// side-menu entry, and the Follow Ups tab in the patient chart. Off => neither route is registered
// and neither menu item renders, so the DOM is identical to what it was before the feature existed.
// There is no backend gate — the API serves any practice-staff user, so this flag is the only thing
// keeping the feature unreachable.
export const SCRIBE_FOLLOW_UPS_FEATURE = "scribeFollowUps";
// LD key: perReportAccess — gates the per-user Reports tab (ENG-1595).
// Target practice-wide, never per-user: the permission config is written by admins but evaluated
// in each viewer's own flag context, so a per-user rollout would let an admin configure Advanced
// mode for someone whose own session resolves the flag off — the config would silently do nothing.
export const PER_REPORT_ACCESS = "perReportAccess";
// LD key: era-check-reconciliation (camelCased by the SDK). Gates the check-reconciliation block on
// the Claim Remittance modal. Off => the two new fields never enter ERA_CLAIM_QUERY, so the request is
// byte-identical to what a backend without SN-19239 accepts — django-restql 400s an unknown field, and
// these ride the modal's main query, so a leak breaks the whole modal rather than just the block.
export const ERA_CHECK_RECONCILIATION_FEATURE = "eraCheckReconciliation";
// LD key: secondary-insurer-balance (camelCased by the SDK). Moving the remaining insurer
// balance to the SECONDARY insurer after a primary adjudication. Gates four surfaces: the
// remaining-balance destination radio on the ERA apply dialog and the manual insurance
// payments/adjustments form (and the `remaining_balance_destination` WRITE key — an older
// backend rejects unknown write keys, so it must be absent when off, not null), the
// As Primary / As Secondary columns + Payer Position filter on the Insurer Receivable report,
// and the moved-to-secondary indicator on the invoice Summary tab. Read side is gated too:
// `insurer_balance_moved_to_secondary_at` is a backend-first RestQL key that 400s the whole
// GET (FieldNotFound) against a backend that predates it, so it is only requested when on.
// Off => every request (queries and payloads) is byte-identical to before the feature existed.
export const SECONDARY_INSURER_BALANCE_FEATURE = "secondaryInsurerBalance";
// LD key: find-next-available-checkout-feature (camelCased by the SDK). Gates the checkout entry
// points into the Find Next Available search: the interval presets + "Find next available" action
// in the "Schedule next appointment?" modal, the shortcut in the Current Visit drawer's
// next-appointment block, and the per-type "Next appointment timeframe" setting (its UI, its write
// payload key, and its RestQL read key — the backend field must be deployed before this flag turns
// on, or the enriched read query 404s and the PATCH payload 400s).
export const FIND_NEXT_AVAILABLE_CHECKOUT_FEATURE =
  "findNextAvailableCheckoutFeature";
// LD key: physician-marketing (camelCased by the SDK). Gates the Physician Marketing tab and the
// /marketing/physician-marketing route (bulk email to referring physicians). Off => no menu entry
// and the route redirects to "../", so the Marketing section renders exactly as it does today. An
// absent flag key evaluates falsy, so this is safe to merge before the flag exists in LaunchDarkly.
export const PHYSICIAN_MARKETING_FEATURE = "physicianMarketing";
// LD key: physician-communications (camelCased by the SDK). Gates the expandable communication
// history row on BOTH Marketing > Physician Marketing and Settings > Physicians. Off => neither
// table changes at all: no toggle column, no extra header cell, the empty-state colSpan stays at 9,
// and no request is made. It is also the deploy-ordering lever — the endpoint it reads
// (GET /referring-physicians/{id}/communications/) 404s until the backend ships, and
// Settings > Physicians is not otherwise flagged, so every practice would see a broken row.
// Deliberately NOT PHYSICIAN_MARKETING_FEATURE: that one means "this practice does bulk physician
// email", which is a different claim from "this practice can see communication history", and
// reusing it would hide a Settings feature from every practice not piloting bulk email.
export const PHYSICIAN_COMMUNICATIONS_FEATURE = "physicianCommunications";
// LD key: intake-physician-review-queue (camelCased by the SDK). SN-19728. Gates the three-way
// "Physicians from patient intake" setting, the "Needs review" filter/chip/dialog on Settings >
// Physicians and its side-menu badge, the chip on the patient chart, and hiding physicians waiting
// for review from physician pickers. Off => every one of those surfaces and requests is identical to
// before: the practice PATCH never carries `intake_physician_handling`, no list asks for
// `intake_review_pending`, and a pending physician renders like any other. The backend matching and
// NPI enrichment ship unflagged.
export const INTAKE_PHYSICIAN_REVIEW_QUEUE_FEATURE =
  "intakePhysicianReviewQueue";
// Sales Coach has NO LaunchDarkly flags: ENG-1707 replaced liveCoachingSessions and
// consultCoachSignals with per-practice DB flags (Practice.live_coaching_enabled /
// consult_debrief_enabled + User.has_access_to_coach) managed via Administration -> Coach Setup.
// LD key: patient-facesheet (camelCased by the SDK). Gates the "Include patient facesheet"
// checkbox in the Send Fax modal. Off => the checkbox never renders, the facesheet query is
// never issued and the send payload is byte-identical to today's, so the whole feature is
// inert rather than merely hidden. An absent flag key evaluates falsy, so this is safe to
// merge before the flag exists in LaunchDarkly.
export const PATIENT_FACESHEET_FEATURE = "patientFacesheet";
// LD key: invoice-table-font-size (camelCased by the SDK). Kill switch for the "Table font size"
// picker in the invoice merge tag's Define Parameters dialog. Read as `?? true`, so an ABSENT key
// keeps the control visible (the feature already shipped in #6650) — create the flag and set it
// to false to hide it. Off => the picker never renders and Apply Parameters stops persisting
// font_size, so tokens saved while hidden render with the historical auto sizing. Tokens that
// already carry font_size keep rendering as saved; the render-side clamp still bounds them.
export const INVOICE_TABLE_FONT_SIZE_FEATURE = "invoiceTableFontSize";
// LD key: invoice-table-tag-edit (camelCased by the SDK). In an editor that writes templates, the invoice
// table tag ({{Patient.SelectedInvoice.WithPredefinedParameters(…)}}) shows as a chip describing the
// table, and clicking it opens Define Invoice Parameters filled from that tag, which then rewrites (or
// removes) the tag in place; "With Predefined Parameters" opens the same dialog and inserts on Apply.
// Off => the tag is its code again and both menu entries behave as before. Read as `=== true`: a new LD
// flag starts on, so create it serving false and check `on` + fallthrough in every environment.
export const INVOICE_TABLE_TAG_EDIT_FEATURE = "invoiceTableTagEdit";
// LD key: insurer-credit-ledger (camelCased by the SDK). One flag gating the whole insurer-credit
// surface: the "hold this refund as credit with the insurer" destination on Issue Refund
// (SN-19060), the "Insurance Credit" payment type + reversal action in the take-payment flow
// (SN-19061), and the Insurance Credit Ledger report (SN-19062). Off => none of the three render,
// no insurer-credit endpoint is called, and every request body stays byte-identical to what it
// was before the feature existed — the backend serializer rejects unknown write keys, so sending
// any of these fields (even as null) against a backend that predates the feature would 400 every
// refund/payment, not just insurer ones.
export const INSURER_CREDIT_LEDGER = "insurerCreditLedger";
// LD key: era-apply-take-back-credit (camelCased by the SDK). Gates the "Apply Insurer Credit"
// row action on the ERA list (SN-19469) that pre-fills the insurer/amount/reference from a
// detected payer take-back and navigates to the existing Insurance Credit apply flow. Read
// alongside ERA_CHECK_RECONCILIATION_FEATURE and INSURER_CREDIT_LEDGER — all three must be on:
// without the first, the action would offer to apply a number the user has no way to see or
// verify; without the second, the destination screen never offers the Insurance Credit payment
// type at all. Off => the ERA grid's Actions column, its persisted width, and its network
// traffic are byte-identical to before this feature existed — no new endpoint is ever called.
export const ERA_APPLY_TAKE_BACK_CREDIT = "eraApplyTakeBackCredit";
// LD key: patient-facesheet-email (camelCased by the SDK). Gates the "Include facesheet as
// attachment" checkbox in the Send Email modal. Separate from PATIENT_FACESHEET_FEATURE on
// purpose: the fax surface has already shipped, so email must be able to merge and enable
// independently rather than riding an already-live flag. Off => the checkbox never renders, the
// facesheet query is never issued and the send payload is byte-identical to today's.
export const PATIENT_FACESHEET_EMAIL_FEATURE = "patientFacesheetEmail";
// LD key: patient-facesheet-print (camelCased by the SDK). Gates the "Patient Facesheet" tile in
// the patient Forms dialog, which opens the standalone Print / Save to E-Docs surface. A third
// flag beside the fax and email ones on purpose — each surface rolls out independently. Off =>
// the tile never renders, the options dialog never mounts (so no Box access-token GET fires) and
// the facesheet patient query is never issued. An absent flag key evaluates falsy, so this is
// safe to merge before the flag exists in LaunchDarkly.
export const PATIENT_FACESHEET_PRINT_FEATURE = "patientFacesheetPrint";
// LD key: active-devices-pdf (camelCased by the SDK). Gates the "Devices PDF" dropdown (Download /
// Print / Save to E-Docs) on the patient Devices screen (`/patients/:id/hearing-aids`). The gate is
// the outer `DevicesPdfMenu`, which returns null before any other hook runs, so off => no patient
// GET, no Box access-token GET, and `@react-pdf/renderer` is never dynamically imported — the
// feature is inert rather than merely hidden. The export is read-only (it prints device data the
// screen has already fetched), so nothing else on the page changes with the flag. An absent flag
// key evaluates falsy, so this is safe to merge before the flag exists in LaunchDarkly.
export const ACTIVE_DEVICES_PDF_FEATURE = "activeDevicesPdf";
// LD key: fax-failure-detail (camelCased by the SDK). Gates showing WHY a fax failed — the reason
// line and category chip on the queue row, and the failure section in the receipt dialog. Off =>
// the fax list RestQL query omits failure_code/failure_category/failure_reason/failure_guidance/
// send_attempt_count/last_attempted_at entirely, because RestQL raises FieldNotFound for an unknown
// key and fails the WHOLE request — asking for them against a backend that predates this feature
// would break every fax list, not just the failed rows. An absent flag key evaluates falsy, so this
// is safe to merge before the flag exists in LaunchDarkly.
export const FAX_FAILURE_DETAIL_FEATURE = "faxFailureDetail";

// Automatic retries for temporarily-failed faxes (busy line, no answer, bad connection). Gates
// the retry line in the fax status cell, the receipt dialog's auto-retry row, the Cancel action,
// AND the two RestQL fields behind them (auto_retry_count, next_retry_at) — same FieldNotFound
// rule as the failure-detail fields above, so the key must stay flag-gated. Read it only through
// useFaxAutoRetryEnabled, which also requires the failure-detail flag: the retry line renders
// inside the failure-detail block, so one flag without the other is a broken half-feature.
export const FAX_AUTO_RETRY_FEATURE = "faxAutoRetry";

// ENG-2511: the Fax Center's Unassigned Faxes queue (default tab, "N new" count, unread markers),
// per-fax read state, the Assign dialog's "Save to E-Docs after assigning" step and the Archive
// wording/icons. Gates the `read` RestQL field and the `unassigned`/`read` list params, so it must
// stay off until the backend that serves them is deployed. With it off, the Fax Center still marks
// every fax read when it opens. Read it only through useFaxUnassignedQueueEnabled.
export const FAX_UNASSIGNED_QUEUE_FEATURE = "faxUnassignedQueue";

// Rollout control for the Billing tab; access is still enrollment + per-user grant.
// Read-only clinic number surfaces (SN — clinic fax/SMS visibility): the fax-queue
// "Your fax number" strip + All Locations popover, the Fax Portal settings numbers
// list, and the inbox "Texting numbers" popover. Off => none of the three render and
// the narrow clinics query behind them is never issued. Ships dark; enable per practice.
export const CLINIC_NUMBERS_FEATURE = "clinicNumbers";

// LD key: chat-ui-v2 (camelCased by the SDK). Selects the Slack-style chat v2
// (features/chat/v2/) at the chat/* route in routes.tsx. Off => v1
// (chat.component.tsx) renders unchanged. ANDed with the practice attribute
// sendbird_chat_enabled, which keeps answering "does this practice have chat".
export const CHAT_UI_V2 = "chatUiV2";

// LD key: chat-earlier-conversations (camelCased by the SDK). Gates chat v2's
// handling of channels imported at the pre-Sendbird migration: the "Earlier
// conversations" sidebar section, Archive/Archive-all, the Archived view, the
// ungated leave action, and the imported-channel identity treatment. Read once
// in chat-v2.component.tsx and drilled as a prop; the AND with chatUiV2 is
// structural (ChatV2 only mounts when that flag is on). Off => v2 behaves
// exactly as before this flag existed. Ships dark; enable per practice.
export const CHAT_EARLIER_CONVERSATIONS = "chatEarlierConversations";

// LD key: email-reply-to-address (camelCased by the SDK). Gates the New Email modal's compact
// sender row: the read-only From line plus the editable "Replies go to" field, prefilled with the
// resolved clinic's no-reply address. Off => the modal renders unchanged and the request body
// never carries a Reply-To participant. An absent flag key evaluates falsy, so this is safe to
// merge before the flag exists in LaunchDarkly.
export const EMAIL_REPLY_TO_ADDRESS_FEATURE = "emailReplyToAddress";

// LD key: google-review-requests-report (camelCased by the SDK). One flag for the whole Review
// Requests report surface: the Marketing > Review Requests page (route + side-menu entry) and the
// caption under the patient header's "Pause review" toggle. Off => the route and menu entry never
// render, the patient header renders byte-identical to before the feature (no status fetch), and
// no /marketing/review-requests/ endpoint is ever called. An absent flag key evaluates falsy, so
// this is safe to merge before the flag exists in LaunchDarkly.
export const GOOGLE_REVIEW_REQUESTS_REPORT_FEATURE =
  "googleReviewRequestsReport";

// Training Scenario Engine (ENG-1767 project), T8/ENG-1777. Deliberately NOT a standalone
// route or nav entry — the nav-placement question (Sam raised it; Home's tab bar is already
// 10 tabs deep) doesn't need answering at all, because Training lives inside the existing
// Onboarding Hub (features/onboarding-hub/) instead: same audience (pre-go-live staff), same
// owner/individual-contributor split it already has, same time window (training is gated
// pre-go-live server-side; the Hub *is* the pre-go-live surface). Gates the "Practice
// Scenarios" / "Team Training Progress" cards in PracticeView / MyTasksView. Also meant to be
// gated server-side by Practice.training_enabled (suno-backend T1), which isn't yet exposed
// on the practice serializer/type — gate is LD-flag-only until that lands.
export const TRAINING_MODULE_FEATURE = "trainingModuleFeature";

// SOPs page: the practice's own internal documents (SOPs / policies), written in
// TinyMCE or uploaded to the practice's Box folder, categorized by tags.
export const INTERNAL_DOCUMENTS_FEATURE = "internalDocumentsFeature";
// SN-19516: the History accordion in the task view dialog (backend ships live).
export const TASK_HISTORY_FEATURE = "taskHistoryFeature";
// The tag-history button next to a record's tag chips, and the dialog it opens. One flag for
// every tagged surface (faxes, invoices, patients, appointments, tasks, ERAs, devices, chart
// notes, clinic stock, conversations) because they all render through the same shared
// components — there is nothing per-surface to stage separately. Backend ships live, per the
// standard BE-live/FE-flag pattern. Off => the button is not rendered and nothing is fetched.
export const TAG_HISTORY_FEATURE = "tagHistoryFeature";
// LD key: zoom-host-start-link (camelCased by the SDK). Gates whether the telehealth video
// icon fetches a fresh Zoom *host* start link before opening, so any internal staff member can
// start the visit instead of being blocked by Zoom's "host required sign-in to start the
// appointment" (SN-19531). Off => the icon opens the guest `zoom_join_url` directly and
// synchronously, exactly as before, and /zoom-start-link/ is never called. On, any failure
// falls back to that same guest link, so the worst case equals the flag-off behaviour. An
// absent flag key evaluates falsy, so this is safe to merge before the flag exists in
// LaunchDarkly.
export const ZOOM_HOST_START_LINK_FEATURE = "zoomHostStartLink";
// SN-19542: "Type" mode in the signature desk (typed name rendered as a script
// signature). LD key: type-to-sign (camelCased by the SDK). Off => the signing
// dialog renders exactly as it did before typed signatures existed.
export const TYPE_TO_SIGN_FEATURE = "typeToSign";
// SN-19567: offers Type to Sign on the STAFF signature in Settings -> Personal
// (Personal Details tab). Its own flag, separate from TYPE_TO_SIGN_FEATURE on
// purpose (same reasoning as the two facesheet flags): the patient signing
// surfaces shipped first under the global flag, and a staff signature is a
// different product decision that must be able to roll out or roll back
// independently. Both flags must be ON for this surface — TYPE_TO_SIGN_FEATURE
// stays the global kill switch for typed signing everywhere.
// LD key: type-to-sign-user-settings.
export const TYPE_TO_SIGN_USER_SETTINGS_FEATURE = "typeToSignUserSettings";
// SN-19556: a second, optional provider on the patient record, plus a free-text role
// ("Jane Smith, Speech Therapy"), for multi-specialty practices where one patient is seen
// by both an audiologist and, say, a speech therapist. LD key: secondary-preferred-provider
// (camelCased by the SDK). The flag gates BOTH the RestQL read keys and the write payload
// keys: `CustomModelSerializer` rejects unknown write keys and RestQL 400s on unknown read
// keys, so an ungated frontend would break every patient save against a backend that
// predates the field. Off => request bodies and queries are byte-identical to before.
export const SECONDARY_PREFERRED_PROVIDER_FEATURE =
  "secondaryPreferredProvider";

// Month-end financial locking (GAAP close) — Arrow Audiology request. Gates the
// Administration → Billing "Close Month" card and the locked-month guards on billing
// forms. The backend enforcement is live unconditionally (a practice with no locked
// months has zero behavior change), so this flag is a UI rollout switch only.
// LD key: month-end-closing (camelCased by the SDK).
export const MONTH_END_CLOSING_FEATURE = "monthEndClosing";

// LD key: sales-coach-dashboard (camelCased by the SDK). Gates the whole Sales Coach dashboard
// surface: the /sales-coach route and its side-menu entry. Off => neither renders and nothing is
// requested. An absent flag key evaluates falsy, so this is safe to merge before the flag exists
// in LaunchDarkly.
//
// Note the deliberate exception to the comment above: Sales Coach has otherwise had NO
// LaunchDarkly flags since ENG-1707, which replaced them with per-practice DB flags. A flag is
// used here anyway because the backend has none of its own: both `/coach/` viewsets ship behind
// the project-wide IsPracticeStaffUser default, with NO env kill switch and NO per-practice
// flag (a deliberate PoC decision recorded in the backend's coach/CLAUDE.md). So this LD flag
// is the only thing that decides whether a practice can reach the surface at all, and it is
// also the only thing that is default-off.
//
// When the feature graduates this becomes Practice.sales_coach_enabled plus a paywall
// entitlement check — enforced server-side — and this flag is deleted.
export const SALES_COACH_DASHBOARD_FEATURE = "salesCoachDashboard";

// SN-19967: Sales Coach v2 scoring. On, AND the backend listing the v2 catalog in
// `/coach/playbook/`'s `available_versions`, every Sales Coach surface reads `/coach/v2/*`.
// Off, the v1 UI is unchanged and makes no v2 request. Read it only through
// `useSalesCoachVersion()` (`features/sales-coach/hooks/sales-coach-version.hook.ts`).
// Delete at cutover (PRD W6.1), when v2 becomes the only version.
export const SALES_COACH_V2_SCORING_FEATURE = "salesCoachV2Scoring";

// SN-19967: hide the per-visit score on a Converted visit, where "1.8 Needs review" beside
// "Converted" reads as a contradiction. On: the worklist and card show "—" and the review window
// shows no score block; the breakdown, "Lowered the score by …" and the Overview are unchanged.
// Off (and absent): every score shows. v1 and v2 alike. A new LaunchDarkly flag starts ON — turn it
// off in every environment before this ships. Read it only through `useHideConvertedScore()`.
export const SALES_COACH_HIDE_CONVERTED_SCORE_FEATURE =
  "salesCoachHideConvertedScore";

// ENG-747 Phase A: client-side stale-build detection (version.json manifest poll +
// passive app-chrome pill), replacing the dead frontend.published WS push. Named
// "V2" because an earlier X-Frontend-Version-header design under the same ticket
// was abandoned unmerged (suno-frontend#5047/suno-backend#5591) before this one.
// Off => no polling, no pill, no BroadcastChannel traffic — byte-identical to
// today. An absent flag key evaluates falsy, so this is safe to merge before the
// flag exists in LaunchDarkly.
export const STALE_BUILD_DETECTION_FEATURE = "staleBuildDetectionV2";

// Warn-only duplicate serial number check on clinic stock add/edit (Intercom
// 215475542135210). When on, the FE sends `confirm_duplicate_serial: false` with
// inventory-product create/update; a 400 carrying `duplicate_serial_matches` opens
// the authorization modal, and confirming resubmits with `true`. Off => the field
// is never sent and the backend performs no check (legacy behavior), so this is
// safe to merge before the flag exists in LaunchDarkly.
export const DUPLICATE_SERIAL_WARNING_FEATURE = "duplicateSerialWarning";

// DEV-2995. On => the appointment form shows a blockers strip above the action bar
// naming what is unmet, and Save stays clickable so the click reveals every error
// inline. Off => today's behavior exactly: Save disables on validity and an empty
// required field prefilled from an old appointment says nothing at all.
export const APPOINTMENT_FORM_BLOCKERS = "appointmentFormBlockers";

// "Quick Add Hearing Aids" bulk-create modal on the Catalog screen: a
// spreadsheet-style grid where each row creates one hearing aid (master
// product + practice product) via POST /master-products/bulk-create-hearing-aids/.
// Off => the button never renders and the endpoint is never called, so this is
// safe to merge before the flag exists in LaunchDarkly.
export const QUICK_ADD_HEARING_AIDS_FEATURE = "quickAddHearingAids";

// "Activate from Suno's Master List" tab inside the Quick Add Hearing Aids modal: search the
// master catalog (GET /master-products/?not_in_catalog=true) and append locked
// rows that create only the practice Product from an existing master (row sends
// `master_product` and omits manufacturer/model/specification). Off => the
// modal renders exactly as today — no tabs, no apply-to-all strip, and the
// `master_product` key is never sent (old backends silently drop the unknown
// row key and then 400 on the missing identity fields — the FE-first rule), so
// this is safe to merge before the flag exists in LaunchDarkly.
export const ACTIVATE_MASTER_PRODUCTS_FEATURE = "activateMasterProducts";

// "Upload File" + "Download Sample File" on the Quick Add Hearing Aids modal's
// Create New tab: parse a CSV/XLSX into grid rows (with a fix-unmatched-values
// mapping dialog) and download the backend's sample .xlsx
// (GET /master-products/quick-add-sample-file/ — a NEW endpoint). Off => neither
// button renders, no parsing code loads and the sample endpoint is never called,
// so this is safe to merge before the flag exists in LaunchDarkly and before the
// backend endpoint deploys (the FE-first rule).
export const QUICK_ADD_FILE_UPLOAD_FEATURE = "quickAddFileUpload";

// ENG-1901. "Copy from left/right ear" on the device edit form and the Existing
// Hearing Aid form: opens a review dialog that fills this form from the opposite
// ear's saved device (everything except serial, ear, product, status). Off => the
// button never mounts, no extra request is made and both forms are byte-identical
// to today, so this is safe to merge before the flag exists in LaunchDarkly.
export const COPY_FROM_OTHER_EAR = "copyFromOtherEar";

// LD key: quick-launcher (camelCased by the SDK). The ⌘K / Ctrl+K quick
// launcher in the app shell (`features/app-layout/quick-launcher`). Off => the
// component renders nothing, binds no hotkey and fetches nothing — the shell is
// byte-identical to before it existed, so this is safe to merge before the flag
// exists in LaunchDarkly. This flag decides who gets the launcher at all;
// individual admin entries inside it (practice switcher, exit admin mode) stay
// gated on the Suno group separately via `QuickLauncherAction.sunoOnly`.
export const QUICK_LAUNCHER_FEATURE = "quickLauncher";

// ENG-2535: offers the redesigned side menu (grouped, fit-to-label, collapsible rail). Off =
// the classic rail for everyone, whatever they chose; on = the new menu unless the person
// switched back. Read only through `useSideMenuChoice`. LD key `sidebar-redesign`.
export const SIDE_MENU_REDESIGN_FEATURE = "sidebarRedesign";

// LD key: walk-in-appointments (camelCased by the SDK). Shows the "Walk-in —
// patient is here now" checkbox on the appointment creation form (today's date
// only), which creates the appointment directly in Arrived status with
// `is_walk_in: true`. Off => the checkbox never renders and neither payload key
// is sent, so the create request is byte-identical to before this feature —
// safe to merge before the backend field/transition deploys.
export const WALK_IN_APPOINTMENTS_FEATURE = "walkInAppointments";

// LD key: patient-review-window (camelCased by the SDK). "Review With Patient"
// on the Patient Profile page — opens the patient's demographics, contact,
// emergency contact, care team and insurance in a separate, chrome-less window
// the front desk drags onto a patient-facing screen. Off => the button never
// mounts and nothing about the profile page changes; the /patient-review route
// stays registered (it is only reachable by opening it) but nothing links to
// it. Frontend-only — the window reads PATIENT_FACESHEET_QUERY, which already
// exists and deliberately omits `ssn`.
export const PATIENT_REVIEW_WINDOW_FEATURE = "patientReviewWindow";

// ENG-1949. "N cards on file" pill beside the HIPAA chip in the expanded patient
// header. Off => the pill never mounts, the header query does not request
// `may_have_cards_on_file`, and no `/cards/` request is made from the header.
// Also requires SAVE_CARD_ON_FILE (the surface it links to).
export const CARD_ON_FILE_HEADER_INDICATOR = "cardOnFileHeaderIndicator";

// LD key: custom-campaign-run-status (camelCased by the SDK). Renders a custom
// campaign's activity — lifetime `send_totals` (sent/failed, stacked bar whose
// segments deep-link into Executed Touchpoints), the `latest_run` only while a wave
// is in flight, and the next cron window — in the "Activity" column of the
// list/grouped rows and as a "Sending" block (Totals / Last wave tabs) on the
// detail page. Gates RENDERING ONLY: the custom-campaigns service sends no RestQL
// `?query=`, so `latest_run` / `send_totals` / `custom_first_executed_at` ride along
// on the existing reads and an older backend simply omits them. Off => the three
// surfaces render the old `getLastExecutedLabel` text byte-for-byte, so this is safe
// to merge before the flag exists in LaunchDarkly and can be flipped as soon as the
// backend ships.
export const CUSTOM_CAMPAIGN_RUN_STATUS_FEATURE = "customCampaignRunStatus";

// LD key: custom-campaign-editing (camelCased by the SDK). Custom-campaign
// versioning: an "Edit" action (detail page + list row) that opens the create
// wizard pre-filled and saves through `POST /clinic-campaigns/{id}/versions/`
// (never PATCH), the save dialogs that ask how an audience change should treat
// already-contacted patients (`audience_intent`), a History tab listing every
// version with Restore, "Reactivate" for an inactive campaign, and the
// "Version N" caption in the Sending block. Gates the new endpoints AND the new
// payload keys (`audience_intent`, `expected_version_no` — unknown-key 400 rule),
// so off => the detail page's inline template save still PATCHes exactly as
// before and nothing calls `/versions/` or `/edit-preview/`. `current_version_no`
// / `contact_memory_since` ride along on the existing reads (no RestQL query), so
// the read side needs no gate. Flip only after the backend ships versions.
export const CUSTOM_CAMPAIGN_EDITING_FEATURE = "customCampaignEditing";
// LD key: custom-campaign-send-test (camelCased by the SDK). "Send test email" /
// "Send test text" beside the template headings on the custom campaign wizard
// (Message + Review steps) and the detail page, plus the Send Test Message
// dialog behind them (`custom-campaigns/send-test/`). Gates the buttons only;
// the endpoint (`POST /marketing/clinic-campaigns/send-test/`) is never called
// while off. Flip only after the backend ships the endpoint and its policy row.
export const CUSTOM_CAMPAIGN_SEND_TEST_FEATURE = "customCampaignSendTest";

// LD key: custom-campaign-text-replies (camelCased by the SDK). ENG-2043. The
// "Text replies" panel on Executed Touchpoints, the Reply column and the Replied
// filter in that table, and the Replies / Unread columns on the practice-wide
// campaigns list. Gates RENDERING ONLY: `insights.replies`, the row's `reply` and
// the list's `reply_totals` ride along on existing reads (the custom-campaigns
// service sends no RestQL `?query=`), and the `replied` query param is only sent
// when the filter is on screen, so an older backend simply ignores it. Off => all
// three surfaces render exactly as before, so this is safe to merge ahead of the
// backend. Email replies are NOT covered by this or anything else: campaign email
// is sent from a no-reply address and Suno ingests no inbound email.
export const CUSTOM_CAMPAIGN_TEXT_REPLIES_FEATURE = "customCampaignTextReplies";
// SN-20053. The Executed Touchpoints tab on a regular (system) campaign's details page:
// the Reach tiles, delivery rate, failure breakdown, 30-day send activity, the
// filterable touchpoint table and its CSV. Also the Activity cell link into that tab
// on /marketing/campaigns. Gates RENDERING ONLY. Turn it on after the backend PR that
// opens `insights`, `all-touchpoints` and `all-touchpoints-csv` to regular
// ClinicCampaign ids has deployed; before that the tab's first request 404s. Off =>
// the details page and the list render exactly as before this flag existed.
export const REGULAR_CAMPAIGN_ACTIVITY_FEATURE = "regularCampaignActivity";
// SN-20127. LD key: regular-campaign-editing (camelCased by the SDK). An Edit button on a regular
// (system) campaign's details page that saves channel, missing-contact fallback, audience, visit
// suppression and excluded tags to every active clinic or to chosen ones, as a new version through
// `POST /marketing/clinic-campaigns/{id}/versions/`, plus a History tab listing those versions. While
// it is on, the page's inline audience and fallback controls become read-only, so there is one edit
// path. Off => the page renders and PATCHes exactly as before, and nothing calls `/versions/`. Turn it
// on after the backend that serves `/versions/` for regular campaigns has deployed. A new LD flag
// starts on, so create it serving false and check `on` + fallthrough in every environment.
export const REGULAR_CAMPAIGN_EDITING_FEATURE = "regularCampaignEditing";

// LD key: ai-image-enhance (camelCased by the SDK). SN-18765.
// TODO(nikolay): what it gates, and the "Off => ..." claim. See the neighbours
// above for the house format.
export const AI_IMAGE_ENHANCE_FEATURE = "aiImageEnhance";

// LD key: compact-top-bar (camelCased by the SDK). ENG-2009. Below 1,760 px the app-wide
// top bar shows New Patient and Privacy Mode as icons and moves referrals, AI
// visualisation, fax and email into a "More" menu (and Administration below 1,200 px), so
// it stops scrolling the page sideways and overlapping itself. Off => the top bar renders
// exactly as before, so this is safe to merge before anyone is targeted. When piloting,
// set the fallthrough to false BEFORE turning it on: it was created with fallthrough true.
export const COMPACT_TOP_BAR = "compactTopBar";
// Additional Bulk Actions (Patients Report): Pause Marketing, Block Review Requests, Set Contact
// Preferences, Remove Tags, plus the "Pause marketing" report filter and the Undo link.
export const ADDITIONAL_BULK_ACTIONS_FEATURE = "additionalBulkActions";
// Tag Manager (Settings > Tags): usage counts, duplicates banner, Merge, Convert, CSV import,
// hide-for-my-practice on Suno global tags.
export const TAG_MANAGER_FEATURE = "tagManager";
// LD key: responsibility-quick-move (camelCased by the SDK). Invoice line items: a one-click
// swap button between the Patient and Insurance/Managed Care Responsibility cells, plus
// checkbox selection with "Move to Patient" / "Move to Insurance" for several lines at once
// (Edit Sale grid), and "Move to Patient/Insurance Responsibility" row actions on the
// read-only line items table (Patient > Billing expanded row). Off => nothing renders.
export const RESPONSIBILITY_QUICK_MOVE_FEATURE = "responsibilityQuickMove";
// LD key: refit-rebilling (camelCased by the SDK). DEV-3169. Adds "Create Refit Invoice" to the
// invoice actions: re-bills an invoice on a new date of service when the payer refused the original
// claim and the patient keeps the same devices. The new invoice carries the claim and the
// receivable but is excluded from revenue, units sold and commission, so a refit counts as one
// sale rather than two. Off => the menu item and the dialog do not render, the REFIT / RE-BILLED
// chips do not render, and no refit field is requested or sent. The backend also gates creation on
// `practice.enable_refit_rebilling`, so the flag alone cannot create one.
export const REFIT_REBILLING_FEATURE = "refitRebilling";

// LD key: deliveries-tab (camelCased by the SDK). Adds the Deliveries page under Inventory -
// one row per hearing aid or earmold the clinic still owes the patient, longest-waiting first.
// Off => the rail entry does not render, the /inventory/deliveries route is not registered and
// no request is made, so the app is byte-identical to before this feature. The list reads
// `status_created_at`, which only exists once SN-19658 is deployed - keeping this off until then
// is what makes a frontend-first merge safe.
export const DELIVERIES_TAB = "deliveriesTab";

// LD key: ambient-scribe-analytics (camelCased by the SDK). SN-19743. Adds a "Show Analytics"
// button to the Scribes list's filter row for business owners and Suno staff; it swaps the list
// for the practice analytics dashboard (KPIs, trends, providers, appointment types, scribes to
// review) read from GET /ai/ambient-scribes/analytics/. Off => no button, no analytics request,
// and `?view=analytics` is ignored. Set the fallthrough to false BEFORE turning it on: a new
// flag is created with fallthrough true.
export const AMBIENT_SCRIBE_ANALYTICS_FEATURE = "ambientScribeAnalytics";
// LD key: ambient-scribe-bulk-download (camelCased by the SDK). Adds row checkboxes and a
// "Download" button to the Scribes list (/medical-scribes) and the patient's Scribes tab (SN-19937):
// select up to 15 scribes and download their notes, transcripts or both as PDFs (one per scribe,
// zipped when more than one).
// Frontend only — it reads the existing scribe, chart-note and transcript-lines endpoints. Off =>
// no checkboxes, no button, and the grid renders exactly as before. Set the fallthrough to false
// BEFORE turning it on: a new flag is created with fallthrough true.
export const AMBIENT_SCRIBE_BULK_DOWNLOAD = "ambientScribeBulkDownload";
// LD key: ambient-scribe-server-audio-download (camelCased by the SDK). SN-19937 — Audio Record
// Details' audio button becomes a split button: the main click downloads the whole recording as an
// MP3 the server converts (GET /ai/ambient-scribes/{id}/audio/?audio_format=mp3, polled), falling
// back to the original WebM; the arrow offers the copy this browser saved while recording. Off =>
// the old "Download Local Audio" button and hook, unchanged. Create it serving false: a new flag
// serves its fallthrough (true). Each download starts a Celery conversion on the backend.
export const AMBIENT_SCRIBE_SERVER_AUDIO_DOWNLOAD =
  "ambientScribeServerAudioDownload";
// LD key: ambient-scribe-merge (camelCased by the SDK). SN-19901 — row checkboxes and a "Merge"
// button on the Scribes list (/medical-scribes) and the patient's Scribes tab: merge 2–10 scribes
// of one patient into one and put the regenerated note in a chart note the user picks. Needs the
// backend's POST /ai/ambient-scribes/merge/ (deploy it first). Off => no checkboxes on the patient
// tab, no Merge button, no new requests, and the list renders exactly as before. Set the
// fallthrough to false BEFORE turning it on: a new flag is created with fallthrough true.
export const AMBIENT_SCRIBE_MERGE = "ambientScribeMerge";

// LD key: ambient-scribe-setup (camelCased by the SDK). SN-19782 — TEMPORARY. Gates the
// Suno-only Administration → Ambient Scribe Setup menu item and route until the backend's
// /paywall/scribe-setup/* endpoints are live in production; off => neither renders and
// nothing calls those endpoints. Remove after launch (Suno-only setup pages are unflagged).
export const AMBIENT_SCRIBE_SETUP_FEATURE = "ambientScribeSetup";
// Receive-only fax numbers (SN-19784): lists each clinic's `additional_fax_phones` under its main
// number in the clinic fax numbers surfaces (fax-queue "All locations" popover, Fax Portal settings
// list). Off => the clinic numbers query does not name the field, so a backend without it never
// sees it (RestQL answers an unknown field with a 400). Turn on only once the backend has shipped.
export const ADDITIONAL_FAX_NUMBERS_FEATURE = "additionalFaxNumbers";
// ENG-1833: chart note History — lists a note's earlier versions (from the audit trail) and copies
// one to the clipboard. Read-only: nothing is written to the note. Backend ships live; the History
// button and the "View history" link are the only entry points. Off => neither renders and the
// note's `crud_events` are never requested.
export const CHART_NOTE_HISTORY_FEATURE = "chartNoteHistory";
// LD key: notification-preview-appointment (camelCased by the SDK). SN-19798 (SN-19678). Send
// Preview Email on Notification Templates, on both the practice tab and appointment types: the
// button, an Appointment picker (the chosen patient's next five upcoming appointments), and a
// backend render through the same code the real notification uses, so {date}, {time} and the
// telehealth link fill in; the confirmation and feedback links are inert placeholders. Off, or not
// yet created => neither editor shows the button. Settings → Templates has its own Send Preview
// Email, which this flag does not touch. Needs POST /message-templates/render-preview-email/, so
// serve true only once the backend has shipped. A new LD flag starts on, so create it serving false.
export const NOTIFICATION_PREVIEW_APPOINTMENT_FEATURE =
  "notificationPreviewAppointment";
// ENG-2105. On => when the practice has `scheduling_enforce_dedicated_slots`, a user who lacks
// `can_override_dedicated_slots` (whatever their role, ENG-2174) cannot book another type into a dedicated
// slot: the legacy form hides the override checkbox and explains why, and the Users > Access tab
// offers the permission. ENG-2154: on also changes how the legacy form shows ANY collision with a
// slot, even where the practice does not enforce: one warning box under the type field, with the
// override checkbox inside it for users who may override. Off => no enforcement UI and the
// collision look from before ENG-2105, with one exception that is not gated: a slot
// reserved for several types accepts any of them (legacy form, legacy drag and V3), where before
// only its first type was accepted. The backend enforces the setting on its own, with no flag, so
// turn this on for a practice before or with its setting, or its front desk gets a bare refusal.
export const SCHEDULING_ENFORCE_DEDICATED_SLOTS =
  "schedulingEnforceDedicatedSlots";

// Practice-level invoice payment terms (Net 30 etc.) with a per-print override (High Tone Hearing).
export const INVOICE_PAYMENT_TERMS_FEATURE = "invoicePaymentTerms";
// ENG-2151. On => a Clinic Stock row whose status is Sold while it still reports available stock
// shows a "?" beside the quantity, opening a dialog that names the contradiction and offers to
// clear the count (only when a patient is attached, so nothing is lost) or mark the item In Stock.
// Off => the quantity cell renders exactly as before and no dialog exists. Serialled rows only:
// a row with no serial is a bulk pile whose Sold label is written by our own sale path, which
// wants a backend guard rather than a prompt. Frontend-only — no backend change to deploy first.
// A new LD flag starts on, so create it serving false.
export const STOCK_DISCREPANCY_INDICATOR = "stockDiscrepancyIndicator";

// Team @mentions (Intercom 215476249230437): type "@" in a chart note, a task description or a task
// comment to pick a teammate. Chart notes: click "Notify" under the editor to send. Tasks and
// comments: saving notifies (backend parses the description pills / reads `mentioned_user_ids`).
// Gates the @ pickers, the Notify bar, the Notified/Seen lines, the chart-note "Mentions" filter,
// the Home → Tasks "Mentioned Me" tab, the bell's Mentions tab and the email setting. Every new
// RestQL read key (`mentions`, `mentioned_users`) and write key (`mentioned_user_ids`,
// `mention_email_notifications_enabled`) is sent only with this on — an older backend 400s them.
// Backend first. A new LD flag starts on, so create it serving false.
export const TEAM_MENTIONS_FEATURE = "teamMentions";

// Teams (Chicagoland's pooled PCCs). Administration → Teams: named practice-wide groups of staff
// that can be @mentioned (chart notes, task descriptions, comments) and assigned tasks — "Unclaimed"
// until a member clicks Take it; the team stays on the task so the whole team can follow it — plus
// the Home → For me landing screen for non-clinical roles (audiologists, admins and owners keep Day
// Sheet). Work sent to a team shows on Home only; the bell and the phone are per-team settings.
// Gates every new RestQL read key (`team`, `team_claimed_at`, `include_teams`) and write key
// (`team`, `team_ids`, `mentioned_team_ids`): an older backend 400s them. Backend first. One flag,
// on per practice by name. A new LD flag starts on, so it was created serving false.
export const TEAMS_FEATURE = "teams";

// SN-19878. On => in the New Email modal, when the email is linked to a patient and To holds
// anyone who is not that patient (another patient, a typed address, a physician outside the
// patient's care team), or holds more than one address, Send first opens a confirm dialog listing
// every address, and a warning line shows under To. Off => sends exactly as before. Frontend-only.
// Created in LD serving false in every environment.
export const EMAIL_RECIPIENT_CONFIRMATION_FEATURE =
  "emailRecipientConfirmation";
// LD key: catalog-entry-split-off (camelCased by the SDK). Edit Product: changing Sub Type no
// longer re-labels the shared catalog entry (which would retroactively move every other
// practice's historical invoice lines between ledger, tax and commission rules). Instead it
// splits off a new, correctly classified entry for this product and leaves everything already
// invoiced exactly where it is. Off => Edit Product sends a byte-identical payload to today and
// issues no new request, so this is safe to merge before the backend is deployed.
// LD key: catalog-entry-split-off (camelCased by the SDK). SN-19689 AND SN-19690 -- one flag
// for both, because they are not separable: SN-19689's whole value is creating a corrected
// entry, and that goes through SN-19690's impact dialog. Edit Product: changing Type or Sub
// Type no longer re-labels the shared catalog entry (which would retroactively move every
// other practice's historical invoice lines between ledger, tax and commission rules).
// Instead it locks the catalog section behind an Edit affordance and routes any classification
// change through a dialog that counts what it would affect, then either splits off a new entry
// or corrects this one in place. Off => Edit Product sends a byte-identical payload to today,
// and neither /change-impact/ nor /reclassify/ is ever called, so this is safe to merge before
// the backend is deployed.
export const CATALOG_ENTRY_SPLIT_OFF_FEATURE = "catalogEntrySplitOff";

// SN-19868 (LD key `ambient-scribe-trial-without-card`). On => the Scribe purchase screen starts
// the user's own free trial in the app with no credit card, wherever the backend offers one
// (`GET /ai/ambient-scribes/trial-offer/`); everywhere else, and once the user has had a seat, it
// is a card checkout of one licence, never worded as a trial. Off => the card checkout only, with
// no trial-offer request. The backend setting AMBIENT_SCRIBE_TRIAL_WITHOUT_CARD_ENABLED must be on
// too, or the screen shows its refusal on a disabled button. A new LD flag starts on, so create it
// serving false.
export const AMBIENT_SCRIBE_TRIAL_WITHOUT_CARD_FEATURE =
  "ambientScribeTrialWithoutCard";

// LD key `ambient-scribe-getting-started`. On => a user in an active Scribe trial who has never
// recorded a scribe (Failed and Cancelled ones do not count) sees a Getting Started guide on the
// Scribes page in place of an empty list, and anyone who has never recorded gets a "Record this
// visit" tip next to the widget's Capture Visit button. The guide
// is also available from a "How Ambient Scribe works" button, which replaces the "Watch Now" demo pill.
// It also lets audiologists who use Scribe manage Scribe templates (`/settings/scribes`).
// Off => the Scribes page, the patient Scribes tab and the widget are exactly as before, templates
// stay admin-only, and the extra "has this user recorded?" request is never sent. A new LD flag
// starts on, so create it serving false.
export const AMBIENT_SCRIBE_GETTING_STARTED = "ambientScribeGettingStarted";

// LD key: call-insights (camelCased by the SDK). ENG-2126. Call-content insights in the Calls
// workspace and the call drawer: the insight card with its correction popover, the "who and why"
// line on call rows, the Opportunities and Spam & vendors modes, and the content-derived follow-up
// rules. Off, or not yet created => none of it renders and the workspace keeps its previous layout.
// Insights only exist for practices with `call_insights_enabled` on the backend, so serve true only
// after that toggle and the backfill. A new LD flag starts on, so create it serving false.
export const CALL_INSIGHTS_FEATURE = "callInsights";

// SN-19902 (LD key `ambient-scribe-recording-resilience`). On => while a Scribe recording is in
// progress in any tab, whichever Suno tab is visible holds a Screen Wake Lock so the computer does
// not idle into sleep; a dropped connection is retried with backoff (waiting for the network to
// come back) instead of pausing after one try; and any stretch of 30 s or more missing from the
// transcript is shown as a card in the recording widget and a snackbar in the other tabs.
// Off => recording behaves exactly as before. A new LD flag starts on, so create it serving false.
export const AMBIENT_SCRIBE_RECORDING_RESILIENCE =
  "ambientScribeRecordingResilience";

// DEV-3388 (LD key `noah-session-picker-new-report`). On => the Audiology tab's "New Audiology
// Report" becomes a split button that generates a report from the patient's latest Noah session (or
// an earlier one), every session report is made through `POST /noah-sessions/<id>/report/`, the
// reports list and the report page name the Noah session, and a failed sync shows a persistent
// "Retry sync" warning. It also adds `noah_session{id,...}` and `noah_sync_failed_at` to the report
// queries, which an older backend rejects, so serve true only after the backend endpoint and the
// `noah_sync_failed_at` column are live. A new LD flag starts on, so create it serving false.
export const NOAH_SESSION_PICKER_NEW_REPORT = "noahSessionPickerNewReport";

// ENG-2277. LD key: html-forms (camelCased by the SDK). HTML Forms: Form templates printed on their
// own page size, placed on the hearing-aid, appointment, patient and loaner surfaces, and converted
// from PDFs. Off => every HTML Forms control is hidden and no new payload or query key is sent.
// It also gates (ENG-2459, which folded their own flags into this one) the print dialog's typeable blanks
// (SN-19949), its "Fill in the blanks" panel and the import review's Items table card (ENG-2447).
export const HTML_FORMS_FEATURE = "htmlForms";

// ENG-2320. LD key: google-reviews-website-widget (camelCased by the SDK). Gates the "Website
// widget" section on Settings > Google Reviews (layout, which reviews, minimum rating, book button,
// scheduler strip, embed code). Also requires the Google Reviews practice + user gate. Off => the
// section never mounts and /google-reviews/widget-settings/ is never called. An absent flag key
// evaluates falsy, so this is safe to merge before the flag exists in LaunchDarkly.
export const GOOGLE_REVIEWS_WEBSITE_WIDGET = "googleReviewsWebsiteWidget";

// ENG-2415. LD key: product-categories (camelCased by the SDK). Practice-defined product categories:
// the Settings › Product Categories page, the category chip and filter on the sale and order pickers,
// the catalog column, filter, bulk edit and form field, the inventory list column and filter, and the
// chip on patient devices. Off => none of it renders, and no `category` key is sent in a query or a
// product payload; CustomModelSerializer 400s an unknown write key, so serve true only once the
// backend `category` field is deployed.
export const PRODUCT_CATEGORIES_FEATURE = "productCategories";

// SN-19617. LD key: summary-font-size-preference (camelCased by the SDK). Writes the user's Summary
// Font Size (Personal Settings) into the audiology report summary's HTML as `font-size: Npx`, so the PDF
// prints what the editor shows: a ticked "Keep the font size consistent" sync, the no-dialog sync into an
// empty summary, and text typed or pasted into an empty summary. Off => sync strips sizes as before and
// nothing is armed. A new LD flag starts on, so check `on` + fallthrough in every environment.
export const SUMMARY_FONT_SIZE_PREFERENCE_FEATURE = "summaryFontSizePreference";

// LD key: appointment-opportunity-field (camelCased by the SDK). SN-19653. "Mark as
// Opportunity" on the appointment create/edit form, plus a "Hearing aids on file" card
// showing each ear's device and its age, and every read site that decides whether a visit
// is an opportunity (Day Sheet badge and count, Appointments report column, outcome dialog,
// Sales Coach reason, scheduler preview row) switching from "the type says so" to "the row
// OR the type says so". Off => the checkbox and the card never mount, no `is_opportunity`
// key is sent on any save, and every read site resolves on the appointment TYPE exactly as
// before — which matters beyond the form, because a CounselEAR import writes the row flag
// directly and un-gating the reads would turn those visits into Opportunities on deploy day
// for practices that never asked. Both report projections add the top-level
// `is_opportunity` token only while this is on (`withOpportunity`); the two shared ones —
// `APPOINTMENT_DEFAULT_QUERY` and `PATIENT_APPOINTMENTS_LIST_QUERY` — carry it un-gated,
// because gating them means threading the flag through ~21 call sites for a read-only
// boolean nothing un-gated reads. The field has existed since `scheduling/0012`, so there is
// no FE-first risk in reading it.
export const APPOINTMENT_OPPORTUNITY_FIELD = "appointmentOpportunityField";
// ENG-2484. LD key: hide-visit-notes-by-role (camelCased by the SDK). Hides visit notes (chart notes of
// type Patient Visit) from anyone who is not in the Audiologists, Business owners or Suno group: the
// Visit Notes tab, visit notes in every chart-note list, the note embedded in an appointment, and the
// documents and AI features that copy its text. Read it only through `useCanViewVisitNotes()`.
// Frontend only: the API still returns visit notes to every practice user, so this hides them on
// screen and is not access control. Off => every surface is byte-identical to before. A new LD flag
// starts on, so check `on` + fallthrough in every environment before relying on it being off.
export const HIDE_VISIT_NOTES_BY_ROLE_FEATURE = "hideVisitNotesByRole";

// SN-19952: send apply_insurer_floor so the backend keeps settled insurer money off the patient on Private Pay invoices.
export const DEDUCT_INSURANCE_FROM_PATIENT_RESP =
  "deductInsuranceFromPatientResp";
// SN-20020. LD key: era-reversal-insurer-refund (camelCased by the SDK). When an ERA claim is a
// reversal (835 status 22 with a negative total paid), the Apply Claim Remittance dialog records an
// insurance refund per reversed line (optionally held as insurer credit) instead of a negative
// payment, and the ERA list marks the row "Reversal". Read alongside INSURER_CREDIT_LEDGER — both
// must be on. Off => the dialog, the list and every request body are byte-identical to before: the
// write-only `era_reversal` key is never sent (an older backend 400s unknown write keys) and no
// refund or sale-item/payment read is issued from the dialog.
export const ERA_REVERSAL_INSURER_REFUND = "eraReversalInsurerRefund";
// SN-20019. LD key: ambient-scribe-notification-settings (camelCased by the SDK). Adds an "Ambient Scribes"
// group to Settings → Personal → Notification Preferences: four switches that mute the bell (and the
// phone push it sends) for SOAP notes, After Visit Summary letters, scribe summaries and Sales Coach
// reviews, saved as `user_preferences.ambient_scribe`. Off => the group never mounts and the save
// payload is byte-identical to before. The backend must be live in production before this serves true
// anywhere: an older backend drops the section silently, so the page would say "saved" and the switches
// would snap back on. Turning it off hides the switches but does not unmute anyone. A new LD flag
// starts on, so check `on` + fallthrough in every environment before relying on it being off.
export const AMBIENT_SCRIBE_NOTIFICATION_SETTINGS =
  "ambientScribeNotificationSettings";
// SN-20024. LD key: era-reversal-convert-payment (camelCased by the SDK). An ERA reversal applied
// before SN-20020 was booked as a negative insurer payment; this adds "Convert to Insurance Refund" to
// such a payment's row menu, which replaces it with an insurance refund of the same amount (optionally
// held as insurer credit) through POST /payments/{id}/convert-to-insurance-refund/. Read alongside
// INSURER_CREDIT_LEDGER — both must be on. Off => no menu item and no request of any kind.
export const ERA_REVERSAL_CONVERT_PAYMENT = "eraReversalConvertPayment";

// SN-20000 (LD key `ambient-scribe-reuse-idb-connection`). On => the recording worker keeps one
// IndexedDB connection for its chunk writes instead of opening a new, never-closed one every 3 s,
// so a long recording no longer leaves hundreds of connections open on the origin. Off => every
// write opens its own connection, exactly as before. A new LD flag starts on, so create it serving
// false and check `on` + fallthrough in every environment.
export const AMBIENT_SCRIBE_REUSE_IDB_CONNECTION =
  "ambientScribeReuseIdbConnection";
/**
 * SN-20101: draw the REM and Test Box charts at one octave = 20 dB (`spl-chart-geometry.ts`), with both
 * ears on one scale, on screen and in the PDF. Off => the old fixed-height charts, each ear on its own
 * scale. Frontend only. A new LD flag starts on, so create it serving false and check `on` + fallthrough
 * in every environment.
 */
export const REM_CHART_PROPORTIONS_FEATURE = "remChartProportions";

// SN-20071. LD key: save-to-edocs-naming (camelCased by the SDK). Every "Upload to E-Docs" opens the
// shared Save to E-Docs dialog (`components/save-to-edocs-dialog`): a document name, pre-filled with the
// surface's own name and editable, above the Box folder picker. Off => each surface shows what it did
// before (the bare folder picker, or `useSaveToEdocs`'s plain "Document Name" field) and uploads under
// the same name. Frontend only. A new LD flag starts on, so check `on` + fallthrough in every
// environment before relying on it being off.
export const SAVE_TO_EDOCS_NAMING_FEATURE = "saveToEdocsNaming";

// LD key: hearingAidDetailsV2. Patient chart › Hearing Aids › device details as one page for the pair:
// a summary band per ear with the device tags, grouped sections, coverage sentences and timeline, and
// one Save for both ears (`patient-hearing-aids/patient-product/pair/`). Also the coverage wording on
// the Devices list cards. Off => the single-device form and the list cards render byte-identical to
// before, and the detail GET asks for nothing new. Practice-targeted; turned off per practice on
// complaint rather than per person. A new LD flag starts off here (created via the API), but check
// `on` + fallthrough in every environment before relying on it.
export const HEARING_AID_DETAILS_V2 = "hearingAidDetailsV2";

// SN-20131. LD key: patient-product-history. The device page's "Status History" card becomes
// "History": every recorded change to the device (serial number, warranty and service plan dates,
// delivery date, ear, notes, status) with who made it and when, read from the easyaudit trail through
// `GET /patient-products/{id}/history/`, fetched only when the card is on screen. Both the classic
// single-device form and the two-ear page. Off => the status-only timeline renders byte-identical to
// before and the history endpoint is never called. Backend ships first (the endpoint). A new LD flag
// starts off here (created via the API), but check `on` + fallthrough in every environment.
export const PATIENT_PRODUCT_HISTORY_FEATURE = "patientProductHistory";

// SN-16712. LD key: mcpConnections. Settings > AI Connections: turn on AI assistant (MCP) access for
// the practice, grant staff write access, revoke connected apps and read the activity log. Off => no
// menu entry, no route, no quick-launcher row. The consent page at /mcp/authorize is not gated: the
// backend kill switch (404 on every /api/mcp/ endpoint) decides whether it can do anything. A new LD
// flag starts on, so create it serving false and check `on` + fallthrough in every environment.
export const MCP_CONNECTIONS_FEATURE = "mcpConnections";

// LD key: templateOwnershipTransfer. Settings › Templates (every section) shows business owners and Suno
// staff a "Transfer templates" button: pick whose templates (anyone who owns one, deactivated staff
// included) and who receives them, and every one of that person's templates changes owner
// (`POST /text-templates/transfer-ownership/`, `GET /text-templates/owners/`). Off => no button and neither
// endpoint is called. Needs the backend endpoints first (403/404 without them). A new LD flag starts on,
// so create it serving false and check `on` + fallthrough in every environment.
export const TEMPLATE_OWNERSHIP_TRANSFER_FEATURE = "templateOwnershipTransfer";

/** SN-19999: details modal on Patient › Billing recurring plans (installments, Tilled status, notes). */
export const RECURRING_PLAN_DETAILS_FEATURE = "recurringPlanDetails";

// ENG-2225: the scheduler stops re-requesting events windows it already has. On: a status update
// over the clinic socket refreshes only the days it touches (and never work shifts), bursts are
// coalesced and held while the appointment form is open, a recently loaded week is served from
// cache on the way back, and the 10-minute poll pauses while the tab is hidden.
export const SCHEDULER_EVENTS_REFETCH_SCOPING = "schedulerEventsRefetchScoping";
